<template>
  <div class="position-relative orders">
    <div class="settings-top-bar sticky-header">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="backButton">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <p class="d-inline-flex">
        </p>
      </div>
    </div>

    <div :class="(loading ? 'show-loader' : 'hide-loader')">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg>
      </div>
    </div>
    <div class="row order-view" v-if="order.status">
      <div class=" col-lg-12 col-md-12 pad-to-15">
        <div class="row" style="margin: 0px;">
          <div class="buttonsCall">
            <div class="row pad-bt-10 height-30-percent display-flex align-items-flex-end">
              <div class="col-lg-12 col-sm-12 col-xs-12 col-print-12 details-label" style="padding-right: 0px !important;">
                <div class="col-lg-1 col-sm-1 col-xs-12 col-print-6 details-label"></div>
                <div class="col-lg-11 col-sm-11 col-xs-12 col-print-6 justify-content-flex-end display-inline-flex">
                  <!-- <div class="ml-10-rem"> -->
                    <!-- start Hio integration -->
                    <template v-if="order.delivery_type === 'DELIVERY' && order.hio_flag">
                      <button class="btn btn-info mar-rt-10 call-courier" :id="'call-hio-courier-' + order.id" v-if="!cancelOrder && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')" @click.prevent="courierHioCall(order.id, order.store_id)"><img src="/static/img/icons/fast-delivery.png"> {{$t("orders.callHioCourier")}}</button>
                      <button class="btn btn-danger mar-rt-10" :id="'cancel-hio-order-' + order.id" v-if="cancelOrder && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')"  @click.prevent="cancelHioCourierOrder(order.id, order.store_id)">{{$t("general.cancelCourier")}}</button>
                      <button class="btn btn-danger mar-rt-10" :id="'cancel-hio-order-disabled-' + order.id" v-if="order.status.id === 'TRANSPORT' || order.status.id === 'CANCELED' || order.status.id === 'NOT_DELIVERED'" disabled="disabled" @click.prevent="cancelHioCourierOrder(order.id, order.store_id)">{{$t("general.cancel")}}</button>
                    </template>
                    <!-- end Hio integration -->
                    <template v-if="order.delivery_type === 'DELIVERY' && order.packageez_flag">
                      <button class="btn btn-info mar-rt-10 call-courier" :id="'call-courier-' + order.id" v-if="!cancelOrder && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')" @click.prevent="courierCall(order.id, order.store_id)"><img src="/static/img/icons/fast-delivery.png"> {{$t("orders.callCourier")}} Eastride</button>
                      <button class="btn btn-danger mar-rt-10" :id="'cancel-order-' + order.id" v-if="cancelOrder && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')"  @click.prevent="cancelCourierOrder(order.id, order.store_id)">{{$t("general.cancelCourier")}} Eastride</button>
                      <button class="btn btn-danger mar-rt-10" :id="'cancel-order-disabled-' + order.id" v-if="order.status.id === 'TRANSPORT' || order.status.id === 'CANCELED' || order.status.id === 'NOT_DELIVERED'" disabled="disabled" @click.prevent="cancelCourierOrder(order.id, order.store_id)">{{$t("general.cancel")}} Eastride</button>
                    </template>

                    <template v-if="order.delivery_type === 'DELIVERY' && order.glovo_flag">
                      <button class="btn btn-info mar-rt-10 call-courier" :id="'call-courier-' + order.id" v-if="(order.glovo_status === 1 || order.glovo_status === 3 || order.glovo_status === 4) && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')" @click.prevent="glovoCourierCall(order.id, order.location_id)"><img src="/static/img/icons/fast-delivery.png"> {{$t("orders.callCourier")}} GLOVO</button>
                      <button class="btn btn-danger mar-rt-10" :id="'cancel-order-' + order.id" v-if="order.glovo_status === 2 && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')"  @click.prevent="cancelGlovoCourier(order.id, order.location_id)">{{$t("general.cancelCourier")}} GLOVO</button>
                      <button class="btn btn-danger mar-rt-10" :id="'cancel-order-disabled-' + order.id" v-if="order.status.id === 'TRANSPORT' || order.status.id === 'CANCELED' || order.status.id === 'NOT_DELIVERED'" disabled="disabled" @click.prevent="cancelGlovoCourier(order.id, order.location_id)">{{$t("general.cancel")}} GLOVO</button>
                    </template>

                    <template v-if="order.delivery_type === 'DELIVERY' && order.integration && order.integration.wolt_drive_status !== undefined">
                      <button class="btn btn-info mar-rt-10 call-courier" :id="'call-courier-wolt-' + order.id" v-if="(order.integration.wolt_drive_status === 1 || order.integration.wolt_drive_status === 3 || order.integration.wolt_drive_status === 4 || order.integration.wolt_drive_status === 6) && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')" @click.prevent="woltDriveCourierCall(order.id, order.location_id)"><img src="/static/img/icons/fast-delivery.png"> {{$t("orders.callCourier")}} WOLT DRIVE</button>
                      <button class="btn btn-danger mar-rt-10" :id="'cancel-order-wolt-' + order.id" v-if="order.integration.wolt_drive_status === 2 && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')" @click.prevent="cancelWoltDriveCourier(order.id, order.location_id)">{{$t("general.cancelCourier")}} WOLT DRIVE</button>
                      <button class="btn btn-danger mar-rt-10" :id="'cancel-order-disabled-wolt-' + order.id" v-if="order.status.id === 'TRANSPORT' || order.status.id === 'CANCELED' || order.status.id === 'NOT_DELIVERED'" disabled="disabled" @click.prevent="cancelWoltDriveCourier(order.id, order.location_id)">{{$t("general.cancel")}} WOLT DRIVE</button>
                    </template>

                    <template v-if="order.delivery_type === 'DELIVERY' && order.delivery_hero_flag">
                      <button class="btn btn-info mar-rt-10 call-courier" :id="'call-courier-dh-' + order.id" v-if="(deliveryHeroStatus === 0 || deliveryHeroStatus === 3 || deliveryHeroStatus === 4) && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')" @click.prevent="deliveryHeroCourierCall(order.id, order.location_id)"><img src="/static/img/icons/fast-delivery.png"> {{$t("orders.callCourier")}} DELIVERY HERO</button>
                      <button class="btn btn-danger mar-rt-10" :id="'cancel-order-dh-' + order.id" v-if="deliveryHeroStatus === 2 && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')" @click.prevent="cancelDeliveryHeroCourier(order.id, order.location_id)">{{$t("general.cancelCourier")}} DELIVERY HERO</button>
                      <button class="btn btn-danger mar-rt-10" :id="'cancel-order-disabled-dh-' + order.id" v-if="order.status.id === 'TRANSPORT' || order.status.id === 'CANCELED' || order.status.id === 'NOT_DELIVERED'" disabled="disabled" @click.prevent="cancelDeliveryHeroCourier(order.id, order.location_id)">{{$t("general.cancel")}} DELIVERY HERO</button>
                    </template>

                    <template v-if="order.delivery_type === 'DELIVERY' && order.rapid_donkey_status > 0">
                      <button class="btn btn-info mar-rt-10 call-courier" :id="'rapid-donkey-call-courier-' + order.id" v-if="order.rapid_donkey_status === 1 || order.rapid_donkey_status === 3 && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')" @click.prevent="callRapidDonkey(order.id)"><img src="/static/img/icons/fast-delivery.png"> {{$t("orders.callCourier")}}</button>
                      <button class="btn btn-danger mar-rt-10" :id="'cancel-order-' + order.id" v-if="order.rapid_donkey_status === 2 && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')"  @click.prevent="cancelRapidDonkey()">{{$t("general.cancelCourier")}}</button>
                      <!-- <button class="btn btn-danger mar-rt-10" :id="'cancel-order-disabled-' + order.id" v-if="order.status.id === 'TRANSPORT' || order.status.id === 'CANCELED' || order.status.id === 'NOT_DELIVERED'" disabled="disabled" @click.prevent="cancelRapidDonkey()">{{$t("general.cancel")}}</button> -->
                    </template>

                    <template v-if="order.grandchef_status === 3">
                      <button class="btn btn-info mar-rt-10" :id="'grandchef-' + order.id" @click.prevent="sendToGrandchef(order.id)">Grandchef</button>
                    </template>

                    <template  v-if="order.hide_from_integration_link == 1">
                      <button class="btn btn-info mar-rt-10" @click="showOrderInIntegrationLink(order.id)">Vectron</button>
                    </template>
                  <template v-if="order.delivery_type === 'DELIVERY' && order.call_chopchop > 0">
                    <button class="btn btn-info mar-rt-10 call-courier" :id="'rapid-donkey-call-courier-' + order.id" v-if="order.call_chopchop == 1" @click.prevent="callChopChopDriver(order.id)"><img src="/static/img/icons/fast-delivery.png"> {{$t("orders.callCourier")}}</button>
                  </template>
                  <template v-if="order.delivery_type === 'DELIVERY' && showDrCarmen() && order.dr_carmen_status == 0">
                    <button class="btn btn-info mar-rt-10 call-courier" :id="'rapid-donkey-call-courier-' + order.id"  @click.prevent="callDrCarmen(order.id)"><img src="/static/img/icons/fast-delivery.png"> {{$t("orders.callCourier")}} Dr Carmen</button>
                  </template>
                  <template v-if="order.delivery_type === 'DELIVERY' && showDrCarmen() && order.dr_carmen_status != 0">
                    <button class="btn btn-danger mar-rt-10" :id="'rapid-donkey-call-courier-' + order.id"  @click.prevent="cancelDrCarmen(order.id)">{{$t("general.cancelCourier")}} Dr Carmen</button>
                  </template>
                  <template v-if="order.delivery_type === 'DELIVERY' && order.tazz_flag && order.tazz_status !== 0">
                    <button class="btn btn-info mar-rt-10 call-courier" :id="'call-courier-' + order.id" v-if="(order.tazz_status === 1 || order.tazz_status === 2) && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')" @click.prevent="tazzCourierCall(order.id, order.location_id)"><img src="/static/img/icons/fast-delivery.png"> {{$t("orders.callCourier")}} TAZZ</button>
                    <button class="btn btn-danger mar-rt-10" :id="'cancel-order-' + order.id" v-if="(order.tazz_status === 3 || order.tazz_status === 4) && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')"  @click.prevent="cancelTazzCourier(order.id, order.location_id)">{{$t("general.cancelCourier")}}</button>
                    <button class="btn btn-danger mar-rt-10" :id="'cancel-order-disabled-' + order.id" v-if="order.status.id === 'TRANSPORT' || order.status.id === 'CANCELED' || order.status.id === 'NOT_DELIVERED'" disabled="disabled" @click.prevent="cancelTazzCourier(order.id, order.location_id)">{{$t("general.cancel")}}</button>
                    <button class="btn btn-primary mar-rt-10" style="background: #674bd2; color: #fff;" :disabled="order.tazz_status !== 3" :id="'set-prep-' + order.id" v-if="order.tazz_status && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')" @click.prevent="tazzSetOrderPrepared(order.id)">{{$t("tazz.orderPrepared")}}</button>
                  </template>
                  <template v-if="order.delivery_type === 'DELIVERY' && order.tazz_laas_flag && order.tazz_laas_status">
                    <button class="btn btn-info mar-rt-10 btn-print" :id="'call-courier-' + order.id" v-if="(order.tazz_laas_status === 1 || order.tazz_laas_status === 3 || order.tazz_laas_status === 4) && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')" @click.prevent="tazzLaasCourierCall(order.id, order.location_id)"><img src="/static/img/icons/fast-delivery.png"> {{$t("orders.callTazzLaasCourier")}}</button>
                    <button class="btn btn-danger mar-rt-10" :id="'cancel-order-' + order.id" v-if="(order.tazz_laas_status === 2) && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')"  @click.prevent="tazzLaasCancelCourierCall(order.id, order.location_id)">{{$t("general.cancelCourier")}}</button>
                    <button class="btn btn-danger mar-rt-10" :id="'cancel-order-disabled-' + order.id" v-if="order.status.id === 'TRANSPORT' || order.status.id === 'CANCELED' || order.status.id === 'NOT_DELIVERED'" disabled="disabled">{{$t("general.cancel")}}</button>
                    <!-- <button class="btn btn-primary mar-rt-10" :disabled="order.tazz_laas_status !== 3" :id="'set-prep-' + order.id" v-if="order.tazz_laas_status && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')" @click.prevent="tazzSetOrderPrepared(order.id)">{{$t("tazz.orderPrepared")}}</button> -->
                  </template>
                  <button class="btn btn-warning mar-rt-10 noprint btn-print"
                          v-if="canShowRefundButton"
                          :disabled="refundLoading || refundAlreadyDone || btReturnPending"
                          @click.prevent="doRefundOrder">
                    <i class="fa fa-undo"></i>
                    <template v-if="refundAlreadyDone">{{$t('orders.refundAlreadyDone')}}</template>
                    <template v-else-if="btReturnPending">{{$t('btPayments.returnPending')}}</template>
                    <template v-else>{{$t('orders.refundOrder')}}</template>
                  </button>
                  <div v-if="btReturnPending" class="text-warning noprint" role="status">
                    {{$t('btPayments.returnHelp')}}
                    <button class="btn btn-sm" @click.prevent="getData">{{$t('btPayments.refresh')}}</button>
                  </div>
                  <button class="btn btn-info mar-rt-10 noprint btn-print" @click.prevent="printPage">
                      <img src="/static/img/icons/print-a4.png">
                      {{$t('orders.print')}}
                  </button>
                  <button class="btn btn-info mar-rt-10 noprint btn-print" @click.prevent="printToIframe">
                    <img src="/static/img/icons/print-a4.png">
                    {{$t('orders.print2')}}
                  </button>
                  <download-excel
                    class="btn btn-icon mar-rt-40 btn-xls noprint"
                    :fetch="orderExportData"
                    :fields="jsonFields"
                    :name="'Comanda ' + order.id"
                    :before-generate="startDownload"
                    :before-finish="finishDownload">
                      {{$t('general.download_xls') }} <img src="/static/img/export_xls.png">
                  </download-excel>
                  <button
                    style=""
                    class="btn btn-info noprint mar-rt-10 btn-print"
                    v-if="showPrintBtn"
                    @click.prevent="sendToPrinter">
                      <img src="/static/img/icons/print-a4.png">
                      {{$t('orders.printerPrint')}}
                  </button>
                  <button
                    :disabled="isFiscalized()"
                    :class="{ 'order-view-payment-type-disabled': isFiscalized() }"
                    style=""
                    class="btn btn-info noprint mar-rt-10 btn-print"
                    @click.prevent="printFiscal">
                      <img src="/static/img/icons/print-a4.png">
                      {{$t('orders.printFiscal')}}
                  </button>
                  <!-- <button
                    v-if="order.company && order.company.print_fiscal_from_dashboard && order.receipt_number"
                    style=""
                    class="btn btn-danger noprint mar-rt-10 btn-print"
                    @click.prevent="printFiscal">
                    <img src="/static/img/icons/print-a4.png">
                    {{$t('orders.printFiscal')}}
                  </button> -->
                  <!-- </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 posunset">
            <div class="card hightfixed posunset noprint">
              <div class="card-content">
                <div class="row noprint">
                  <div class="col-sm-12">
                    <div class="row ">
                      <div class="col-sm-8">
                        <h6 class="noprint">
                          {{$t('orders.updateStatus')}}
                          <span
                            v-if="order && order.payment_type"
                            style="color: red; margin-left: 10px;"
                          >
                            {{ order.payment_type }}
                            <span v-if="order.transaction_type_id">
                              ({{ order.transaction_type_id }})
                            </span>
                          </span>
                        </h6>
                      </div>
                      <div class="col-sm-4"
                        v-if="order.status.id == 'NEW' || order.status.id == 'PROCESSING'"
                        style="text-align: right;"
                        >
                        <button class="btn btn-default edit" @click="editOrderNow()">
                          <i class="fa fa-pencil"></i>
                          {{$t('orders.editOrder')}}
                        </button>
                      </div>
                    </div>
                    <hr class="noprint" style="clear:both;">
                  </div>
                </div>
                <div class="row pad-bt-15 sticky-order-view-header noprint">
                  <div class="col-md-12">
                    <div class="pull-left status-line pad-to-10 order-buttons resize-method overflow-container">
                      <template v-for="(sts, i) in orderStatuses">
                        <button class="btn btn-status-margin tablet-overflow "
                          :disabled="(!sts.isAllowed || order.is_refunded === 1 || btStatusBlocked(sts.type)) || deliveredStatusValidation(sts)"
                          :class="(sts.type === 'NOT_DELIVERED' ? 'not-delivered-button' : '') + ' ' + (sts.type === 'CANCELED' ? 'canceled-button' : '') + ' ' + classForBtn + ' ' + ((currentOrdersStatus === sts.type ) ? sts.type : '') + ' ' +'mr-1-rem current btn-' + orderStatusClass(sts.type)" @click.prevent="changeStatusFromButtons(sts.type)"
                        >
                          {{changeDeliveryStatusForLabel(sts.type)}}
                          <!-- v-bind:style="{ backgound: orderStatusButtonColor(sts.type), textColor:'white' }" -->
                        </button>
                      </template>
                    </div>
                    <div class="pull-right" style="display:inline-flex">
                      <select class="form-control" @change.prevent="changeStatus" v-model="currentOrdersStatus">
                        <option v-for="(sts, i) in orderStatuses"
                                :disabled="(!sts.isAllowed || order.is_refunded === 1 || btStatusBlocked(sts.type)) || deliveredStatusValidation(sts)"
                                :value="sts.type">
                                {{changeDeliveryStatusForLabel(sts.type)}}
                              <!-- {{$t('ordersStatus.' + changeDeliveryStatusForLabel(sts.type)}} -->
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="card">
              <div class="card-content mar-15">

                <div class="row">
                  <div class="col-sm-12 mar-bt-20">
                    <div class="pull-left print-lg-font">
                      <img src="/static/img/icons/icon-shopping-cart.png" class="mar-rt-5">
                      {{$t('orders.single')}}
                      <span style="text-transform:none; font-weight: 600;">#{{order.token}}</span>
                      <span style="margin-right: 20px; margin-left: 20px;">ID: {{order.id}}</span>
                      <span v-if="order.app_id" style="margin-right: 20px;">App ID: {{order.app_id}}</span>
                    </div>
                    <div class="pull-right">{{$t('orders.ordDetails')}}</div>
                    <h6 v-if="order.check_in" style="display: flex; align-items: center; width: auto; padding-left: 30px; color: #5e35b1;">Checked</h6>
                  </div>
                </div>
                <div class="row display-flex resized-min-width-1600 box-bg-white">

                  <div class="col-md-6 col-print-6">
                    <div class="row pad-bt-10" v-if="order && order.production_details && order.production_details.location">
                      <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label">{{$t('orders.ordLocation')}}</div>
                      <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12"><span>{{order.production_details ? order.production_details.location.name : '-'}}</span></div>
                    </div>

                    <div class="row pad-bt-10">
                      <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6">{{$t('orders.date')}}</div>
                      <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6"><span>{{formatDate(order.created_at)}}</span></div>
                    </div>
                    <div class="row pad-bt-10">
                      <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6">{{$t('orders.madeAt')}}</div>
                      <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6"><span>{{formatTime(order.created_at)}}</span></div>
                    </div>

                    <div class="row pad-bt-10" v-if="order.delivery_type !== 'EAT_LOCATION' && order.delivery_type !== 'SELF_ORDERING'">
                      <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label pad-to-10 col-print-6 text-color-red"><span style="font-size:larger">{{$t('orders.pickupTime')}}</span></div>
                      <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6">
                        <template  v-if="!(order.just_date == 1)">
                          <div style="margin-right: 10px; display: inline-block;">
                            <el-time-picker
                              :disabled="true"
                              v-model="order.formatted_pickup_datetime"
                              class="in-inline-120"
                              arrow-control
                              :value-format="timeFormat" :format="timeFormat"
                              placeholder="Select time">
                            </el-time-picker>
                          </div>
                        </template>
                        <span style="background: #fff; border: 1px solid #7C8DB5; font-size: 14px; padding: 12px 10px; border-radius: 6px; display: inline-block; cursor: not-allowed;">{{order.formatted_date_pickup_datetime}}</span>
                        <!-- <button class="btn btn-success btn-icon noprint" disabled @click.prevent="updateHour" :title="$t('general.save')"><i class="ti-save"></i></button> -->
                      </div>
                    </div>
                    <div class="row pad-bt-10" v-if="order.delivery_type == 'EAT_LOCATION'">
                      <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6 text-color-red"><span style="font-size:larger">{{$t('orders.reservationTime')}}</span></div>
                      <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6 ">
                        <span>{{formatDate(order.pickup_datetime)}} {{formatTime(order.pickup_datetime)}}</span>
                      </div>
                    </div>

                    <template  v-if="!(order.just_date == 1)">
                      <template  v-if="order.delivery_type !== 'EAT_LOCATION' && order.delivery_type !== 'SELF_ORDERING'">
                        <div class="row pad-bt-10" >
                          <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label pad-to-10 col-print-6"></div>
                          <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6 order-delivery-time-buttons justify-space-evenly pad-lf-0">
                            <template v-for="min in orderTimeDelivery()">
                              <button :disabled="order.status && order.status.id === 'DELIVERED'" class="btn btn-info btn-icon noprint mr-1-rem hour-button" @click="automatUpdateHour(min, 'add')" :title="$t('general.save')">+{{min}}m</button>
                            </template>
                          </div>
                        </div>
                        <div class="row pad-bt-10" >
                          <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label pad-to-10 col-print-6"></div>
                          <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6 order-delivery-time-buttons justify-space-evenly pad-lf-0">
                            <!-- this is not used because dinamic width needed foreach button -->
                            <!-- <template v-for="min in orderTimeDelivery()">
                              <button class="btn btn-danger btn-icon noprint mr-1-rem hour-button" @click="automatUpdateHour(min, 'sub')" :title="$t('general.save')">-{{min}}m</button>
                            </template> -->
                            <button class="btn btn-danger btn-icon noprint mr-1-rem hour-button" :disabled="order.status && order.status.id === 'DELIVERED'"  style="width: 47px;" @click="automatUpdateHour(5, 'sub')" :title="$t('general.save')">-5m</button>
                            <button class="btn btn-danger btn-icon noprint mr-1-rem hour-button" :disabled="order.status && order.status.id === 'DELIVERED'"  style="width: 51px;" @click="automatUpdateHour(15, 'sub')" :title="$t('general.save')">-15m</button>
                            <button class="btn btn-danger btn-icon noprint mr-1-rem hour-button" :disabled="order.status && order.status.id === 'DELIVERED'"  style="width: 54px;" @click="automatUpdateHour(30, 'sub')" :title="$t('general.save')">-30m</button>
                            <button class="btn btn-danger btn-icon noprint mr-1-rem hour-button" :disabled="order.status && order.status.id === 'DELIVERED'"  style="width: 54px;" @click="automatUpdateHour(45, 'sub')" :title="$t('general.save')">-45m</button>
                            <button class="btn btn-danger btn-icon noprint mr-1-rem hour-button" :disabled="order.status && order.status.id === 'DELIVERED'"  style="width: 55px;" @click="automatUpdateHour(55, 'sub')" :title="$t('general.save')">-60m</button>
                          </div>
                        </div>
                      </template>
                    </template>

                    <template v-if="order.user_labeling">
                      <div class="row pad-bt-10" >
                        <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6">{{$t('orders.note')}}</div>
                        <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6">
                          <template v-if="order.user_labeling">
                            <span class="text-danger">{{convetLabelingJson(order.user_labeling)}}</span>
                          </template>
                        </div>
                      </div>
                    </template>

                  </div>

                  <div class="col-md-6 col-print-6" _style="padding-right: 0px !important;">
                    <div class="height-70-percent">
                      <div class="row pad-bt-10">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('orders.payment')}}</div>
                        <div class="col-lg-7 col-sm-5 col-xs-12 col-print-6">
                          <span :style="(order.payment_type == 'CARD' ? 'color:#7AC29A; font-size:larger;' : '')">{{$t('paymentTypes.' + order.payment_type)}}</span>
                          <span v-if="order.payment_type === 'CARD' && order.is_refunded === 0" v-html="getPaymetnStatus(order.capture_transaction_status)"></span>
                          <div v-if="order.payment_id === 'btIpay'" class="help-block noprint">
                            <strong>BT iPay</strong> — {{$t('btPayments.captureHelp')}}
                            <button class="btn btn-sm" @click.prevent="getData">{{$t('btPayments.refresh')}}</button>
                          </div>
                          <span v-if="order.payment_type === 'CARD' && order.is_refunded === 1">
                            - <span class="text-danger">{{$t('orders.amountRefunded')}}</span>
                            <br>
                            <span class="text-muted"><small>{{$t('orders.amountIntegralRefunded')}}</small></span>
                          </span>
                        </div>
                      </div>

                      <div v-if="order.payment_type == 'ROOM' && order.integration" class="row pad-bt-10">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('orders.roomNumber')}}</div>
                        <div class="col-lg-7 col-sm-5 col-xs-12 col-print-6">
                          <span>
                            <template>{{ order.integration.clock_pms_room_number }}</template>
                          </span>
                        </div>
                      </div>

                      <div v-if="order.flags && order.flags.pager_number" class="row pad-bt-10">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('orders.pagerNumber')}}</div>
                        <div class="col-lg-7 col-sm-5 col-xs-12 col-print-6">
                          <span>{{ order.flags.pager_number }}</span>
                        </div>
                      </div>

                      <div class="row pad-bt-10">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('general.deliveryMethod')}}</div>
                        <div class="col-lg-7 col-sm-5 col-xs-12 col-print-6">
                        <span>
                          <template v-if="order.company_id === 31 && order.delivery_type === 'MEET_HALF'">Due Drive</template>
                          <template v-if="order.company_id === 46 && order.delivery_type === 'MEET_HALF'">Yumm Drive</template>
                          <template v-else>{{$t('deliveryTypes.' + order.delivery_type)}}</template>
                        </span></div>
                      </div>
                      <div class="row pad-bt-10" v-if="order.delivery_type == 'MEET_HALF'">
                        <!-- is_allowed_on_hold and check_in are SUPPOSED to be ON, PIATA 9 -->
                        <template v-if="order.company.is_allowed_on_hold">
                          <template v-if="order.check_in">
                            <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6">{{$t('orders.meetupLocation')}}</div>
                            <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6"><span>{{order.delivery_details ? order.delivery_details.location.name : ''}}</span></div>
                          </template>
                        </template>
                        <template v-else>
                          <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6">{{$t('orders.meetupLocation')}}</div>
                          <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6"><span>{{order.delivery_details ? order.delivery_details.location.name : ''}}</span></div>
                        </template>
                      </div>
                      <div class="row pad-bt-10" v-if="order.delivery_type === 'EAT_LOCATION'">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('orders.reservationSeats')}}</div>
                        <div class="col-lg-7 col-sm-5 col-xs-12 col-print-6"><span>{{order.delivery_details ? order.delivery_details.how_many : '-'}}</span></div>
                      </div>
                      <div class="row pad-bt-10" v-if="order.order_from">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('addOrder.tags')}}</div>
                        <div class="col-lg-7 col-sm-5 col-xs-12 col-print-6"><span>
                          <template v-if="order.delivery_type === 'SELF_ORDERING'">{{order.order_from}}</template>
                          <template v-else>{{$t('addOrder.' + order.order_from)}}</template>
                        </span></div>
                      </div>
                      <div class="row pad-bt-10" v-if="order.table_data && order.delivery_type === 'EAT_LOCATION'">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('addOrder.fromTable')}}</div>
                        <div class="col-lg-7 col-sm-5 col-xs-12 col-print-6">
                          <span>
                            <span v-if="order.table_data['type']">{{order.table_data['type']}}</span>
                            <span v-if="order.table_data['zone']">{{order.table_data['zone']}}</span>
                            <span v-if="order.table_data['number']">{{order.table_data['number']}}</span>
                          </span>
                        </div>
                      </div>
                      <div class="row pad-bt-10" v-if="order.expressoft_id">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('orders.expresoftStatus')}}</div>
                        <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12">
                          <span v-if="order.expressoft_id == 'in_queue'">{{$t('orders.expresoftQueue')}}</span>
                          <span class="text-color-red edit-icon-pointer" v-if="order.expressoft_id == 'error'" @click="showExpressoftError()">{{$t('orders.expresoftError')}}</span>
                          <span v-if="order.expressoft_id && order.expressoft_id != 'in_queue' && order.expressoft_id != 'error'" :data-expressoft_id="order.expressoft_id">{{$t('orders.expresoftSuccess')}}</span>
                        </div>
                      </div>
                      <div class="row pad-bt-10" v-if="order.freya_status">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('orders.freyaStatus')}}</div>
                        <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12">
                          <span>{{$t('orders.freyaStatus' + order.freya_status)}}</span>
                        </div>
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"></div>
                        <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12 text-color-red" v-if="order.freya_status === 3">
                          <span>{{$t('orders.freyaSendAgain')}}</span><i class="fa fa-repeat" @click="resendOrderToFreya(order.id)"></i>
                        </div>
                      </div>
                      <div class="row pad-bt-10" v-if="order.rkeeper_status">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('orders.rkeeperStatus')}}</div>
                        <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12">
                          <span>{{$t('orders.freyaStatus' + order.rkeeper_status)}}</span>
                        </div>
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"></div>
                        <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12 text-color-red" v-if="order.rkeeper_status === 3">
                          <span>{{$t('orders.freyaSendAgain')}}</span><i class="fa fa-repeat" @click="resendOrderToRKeeper(order.id)"></i>
                        </div>
                      </div>
                      <div class="row pad-bt-10" v-if="order.magister_status">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('magister.magisterStatus')}}</div>
                        <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12">
                          <span>{{$t('magister.magisterStatus' + order.magister_status)}}</span>
                        </div>
                      </div>
                      <div class="row pad-bt-10" v-if="order.delivery_type === 'DELIVERY' && order.glovo_flag">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('orders.glovoStatus')}}</div>
                        <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12">
                          <template v-if="!order.glovo_logs">
                            <span>{{$t('orders.courierStatus1')}}</span>
                          </template>
                          <template v-else>
                            <span :class="order.glovo_status === 4 ? 'company-text' : ''">{{$t('orders.courierStatus' + order.glovo_status)}}</span>
                          </template>
                          <i
                            class="fa fa-eye mar-lt-5"
                            style="cursor: pointer;"
                            :title="$t('orders.glovoLaasEvents')"
                            @click.prevent="getGlovoLaasWebhookLogs(order.id)"
                          ></i>
                        </div>
                      </div>
                      <div class="row pad-bt-10" v-if="order.delivery_type === 'DELIVERY' && order.integration && order.integration.wolt_drive_status">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('orders.woltDriveStatus')}}</div>
                        <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12">
                          <span :class="order.integration.wolt_drive_status === 4 ? 'company-text' : ''">{{$t('orders.courierStatus' + order.integration.wolt_drive_status)}}</span>
                          <i
                            class="fa fa-eye mar-lt-5"
                            style="cursor: pointer;"
                            :title="$t('orders.woltDriveEvents')"
                            @click.prevent="getWoltDriveWebhookLogs(order.id)"
                          ></i>
                        </div>
                      </div>
                      <div class="row pad-bt-10" v-if="order.delivery_type === 'DELIVERY' && order.delivery_hero_flag">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('orders.deliveryHeroStatus')}}</div>
                        <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12">
                          <span :class="deliveryHeroStatus === 4 ? 'company-text' : ''">{{$t('orders.courierStatus' + (deliveryHeroStatus || 1))}}</span>
                          <i
                            class="fa fa-eye mar-lt-5"
                            style="cursor: pointer;"
                            :title="$t('orders.deliveryHeroEvents')"
                            @click.prevent="getDeliveryHeroWebhookLogs(order.id)"
                          ></i>
                        </div>
                      </div>
                      <!-- <div class="row pad-bt-10" v-if="order.delivery_type === 'DELIVERY' && order.tazz_flag && order.tazz_status !== 0">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('orders.tazzStatus')}}</div>
                        <template v-if="!order.tazz_logs">
                          <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12">
                            <span>{{$t('tazz.tazzStatus1')}}</span>
                          </div>
                        </template>
                        <template v-else>
                          <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12">
                            <span>{{$t('tazz.tazzStatus' + order.tazz_status)}}</span>
                          </div>
                        </template>
                      </div>
                      <div class="row pad-bt-10" v-if="order.magister_status">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('magister.magisterStatus')}}</div>
                        <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12">
                          <b>{{$t('magister.magisterStatus' + order.magister_status)}}</b>
                        </div>
                      </div>
                      <div class="row pad-bt-10" v-if="order.delivery_type === 'DELIVERY' && order.tazz_laas_flag && order.tazz_laas_status">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('orders.tazzDirectStatus')}}</div>
                        <template v-if="!order.tazz_laas_logs">
                          <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12">
                            <b>{{$t('tazz.tazzStatus1')}}</b>
                          </div>
                        </template>
                        <template v-else>
                          <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12">
                            <b>{{$t('tazz.tazzStatus' + order.tazz_laas_status)}}</b>
                          </div>
                        </template>
                      </div> -->

                      <div class="row pad-bt-10" v-if="order.delivery_type === 'DELIVERY' && order.boogit_flag && order.boogit_status">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('boogit.boogitStatus')}}</div>
                        <template v-if="!order.boogit_logs">
                          <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12">
                            <b>{{$t('boogit.boogitStatus1')}}</b>
                          </div>
                        </template>
                        <template v-else>
                          <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12">
                            <b>{{$t('boogit.boogitStatus' + order.boogit_status)}}</b>
                          </div>
                        </template>
                      </div>
                      <div class="row pad-bt-10" v-if="order.company && order.company.print_fiscal_from_dashboard">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('orders.receipt')}}</div>
                        <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12">
                          <span v-if="order.receipt_number">{{$t('orders.printedReceipt')}}</span>
                          <span v-if="!order.receipt_number">{{$t('orders.notPrintedReceipt')}}</span>
                        </div>
                      </div>
                      <!-- <template v-if="order.comments">  -->
                        <div class="row pad-bt-10">
                          <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"><template v-if="order.comments">{{$t('orders.custComments')}}</template></div>
                          <div class="col-lg-7 col-sm-5 col-xs-12 col-print-6 " :class="order.comments ? 'text-danger' : ''"> <template v-if="order.comments"><span v-html="order.comments || '<small>'+$t('orders.none')+'</small>'"></span></template></div>
                        </div>
                      <!-- </template> -->
                      <template v-if="order.cancel_order_reason">
                        <div class="row pad-bt-10">
                          <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('orders.cancel_order_reason')}}</div>
                          <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12">
                            <span style="color:red">{{order.cancel_order_reason}}</span>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div> <!--  end col-md-12  -->

          <div class="col-md-12 col-print-12" v-if="order.customer && order.customer.email && !order.customer.email.includes('@tableTapTasty.com')" style="display: flex; justify-content: space-between; margin-bottom: 20px; padding: 0;">
            <div :class="(order.delivery_type == 'DELIVERY' && order.address && order.address.shipping ? 'col-md-6 col-print-6' : 'col-md-12 col-print-12')">
              <div class="card" style="margin: auto; height: 100%;">
                <div class="card-content">
                  <div class="row">
                    <div class="col-xs-12">
                      <h6 class="mar-to-0"> <img class="icon-card-header" src="/static/img/icons/user-sm.png">  {{$t('orders.custDetails')}}</h6>
                      <hr class="sm">
                    </div>
                  </div>
                  <div class="row pad-bt-10">
                    <div class="col-lg-4 col-sm-3 col-xs-12">
                      <div :class="{ 'company-text': order.billing_data }">
                        {{ order.billing_data ? $t('orders.legalPerson') : $t('orders.individual') }}
                      </div>
                    </div>
                  </div>
                  <div class="row pad-bt-10">
                    <div class="col-lg-3 col-sm-3 col-xs-12 details-label"><div>{{$t('customers.name')}}</div></div>
                    <div class="col-lg-6 col-sm-8 col-xs-12" v-if="order.delivery_details_firstname"><span>{{order.delivery_details_firstname }} </span></div>
                    <div class="col-lg-6 col-sm-8 col-xs-12" v-else=""><span>{{order.customer ? order.customer.firstname : ''}} {{order.customer ? order.customer.lastname : ''}}</span></div>
                  </div>
                  <div class="row pad-bt-10">
                    <div class="col-lg-3 col-sm-3 col-xs-12 details-label"><div>{{$t('customers.email')}}</div></div>
                    <div class="col-lg-6 col-sm-8 col-xs-12" @click="copyToClipboard(order.customer ? order.customer.email : '')" ><span>{{order.customer ? order.customer.email : ''}}</span></div>
                  </div>
                  <div class="row pad-bt-10">
                    <div class="col-lg-3 col-sm-3 col-xs-12 details-label"><div>{{$t('customers.phone')}}</div></div>
                    <div v-if="order.delivery_details_phone" class="col-lg-7 col-sm-8 col-xs-12" @click="copyToClipboard(order.delivery_details_phone)"><span>{{order.delivery_details_phone}}</span></div>
                    <div v-else class="col-lg-6 col-sm-8 col-xs-12" @click="copyToClipboard((order.customer && order.customer.phone) ? order.customer.phone : '-')"><span>{{(order.customer && order.customer.phone) ? order.customer.phone : '-'}}</span></div>
                  </div>
                  <div v-if="order.country_code || order.country_prefix" class="row pad-bt-10">
                    <div class="col-lg-3 col-sm-3 col-xs-12 details-label"><div>{{$t('orders.orderCountryPrefix')}}</div></div>
                    <div v-if="order.country_code" class="col-lg-6 col-sm-8 col-xs-12">
                      <span>{{order.country_code}}</span>
                      <span v-if="order.country_code && order.country_prefix">,</span>
                      <span>+{{order.country_prefix}}</span>
                    </div>
                  </div>
                  <div v-if="order.customer.comment" class="row pad-bt-10">
                    <div class="col-lg-3 col-sm-3 col-xs-12 details-label"><div>{{$t('customers.commentsLabel')}}</div></div>
                    <div class="col-lg-6 col-sm-8 col-xs-12" @click="copyToClipboard(order.customer ? order.customer.comment : '')" ><p><span>{{order.customer ? order.customer.comment : ''}}</span></p></div>
                  </div>
                  <div v-if="order.billing_data" class="row pad-bt-10">
                    <div class="col-lg-3 details-label">
                      <b class="company-text">
                        {{ $t('orders.billingInfo') }}
                      </b>
                    </div>
                    <div class="col-lg-6 col-sm-8 col-xs-12" @click="copyToClipboard(order.customer ? order.billing_data : '')" >
                      <p style="color:red">
                        <b>{{order.billing_data ? order.billing_data : ''}}</b>
                      </p>
                    </div>
                  </div>
                  <div v-if="order.smartbill_is_active && order.billing_data" class="row pad-bt-10">
                    <div class="col-lg-3 details-label">
                      <b class="company-text">
                        {{ $t('paymentPage.invoice') }}
                      </b>
                    </div>
                    <div v-if="order.billing_data && order.status.id === 'DELIVERED'" class="col-lg-6 col-sm-8 col-xs-12">
                      <p>
                        <a :href="this.apiUrl + 'open-order-invoice?token=' + this.$session.get('token') + '&order_id=' + this.order.id" target="_blank">Vezi factura</a>
                      </p>
                    </div>
                  </div>
                  <div v-if="order.smartbill_is_active && !order.smartbill_send_auto && order.billing_data" class="col-lg-12 col-sm-11 col-xs-12 col-print-6 justify-content-flex-end display-inline-flex mar-bt-15">
                    <button
                      :disabled="!(order.status.id === 'DELIVERED')"
                      class="btn btn-info noprint"
                      @click.prevent="emitInvoice()">
                      <i class="fa fa-print print-icon"></i>
                      {{$t('settingCompany.sendInvoice')}}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <template v-if="order.delivery_type == 'DELIVERY' && order.glovo_status != 5 && order.address && order.address.shipping">
              <div class="col-md-6 col-print-6" >
                <div class="card address-box" style="margin: auto; height: 100%;">
                  <div class="card-content">
                    <h6><img class="icon-card-header" src="/static/img/icons/icon-address.png"> {{$t('orders.shipping')}}</h6>
                    <hr class="sm">
                    <div class="address-content">
                        <b>{{order.address.shipping.address_name ? order.address.shipping.address_name : '' }}</b><br/>{{order.address.shipping.street ? order.address.shipping.street : ''}} {{order.address.shipping.number ? order.address.shipping.number : ''}}, {{order.address.shipping.apartment ? order.address.shipping.apartment : ''}}<br/>
                        {{order.address.shipping.city ? order.address.shipping.city : ''}},
                        {{order.address.shipping.state ? order.address.shipping.state : ''}}<br/>
                        <span v-show="order.address.shipping.country">{{order.address.shipping.country ? order.address.shipping.country : ''}}<br/></span>
                        {{order.address.shipping.other_info ? order.address.shipping.other_info : ''}}

                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <div class="col-md-12">
            <div class="card">
              <div class="">

                <table class="table orders-table orders-table--items">
                  <thead>
                      <tr>
                        <th>{{$t('orders.name')}}</th>
                        <th>{{$t('orders.category')}}</th>
                        <th class="text-center">{{$t('orders.qty')}}</th>
                        <th class="text-center">{{$t('orders.unit_price')}}</th>
                        <th class="text-center">{{$t('orders.totals_discount')}}</th>
                        <th class="text-center">{{$t('orders.total')}}</th>
                      </tr>
                  </thead>
                  <tbody>
                    <template v-for="customer in order.parts">
                      <tr v-if="customer.is_open_order && order.order_type=='GROUP'" class="active">
                        <td colspan="4">{{$t('customers.single')}}: {{customer.customer_name}}</td>
                        <td colspan="2" v-if="order.is_split_pay">{{$t('customers.pay')}}:
                          <span v-if="customer.payment_type">{{$t('paymentTypes.' + (customer.payment_type).toUpperCase() )}}</span>
                          <span v-else-if="customer.is_open_order">-Open-</span>
                          <span v-else>-Pending-</span>
                        </td>
                      </tr>

                      <template v-if="!customer.is_open_order">
                        <template v-for="(prod, prodIndex) in getPartItems(customer)">
                          <template v-if="
                            order.status.id != 'OPEN_DRAFT' ||
                            (
                              order.status.id == 'OPEN_DRAFT' &&
                              (prod.hasOwnProperty('status') && prod.status != 'Draft')
                            )
                          ">
                            <tr
                              class="orders-table__item-row"
                              :class="{ 'orders-table__item-row--has-options': getItemOptions(prod).length }"
                              :key="'p-' + (prod.id || prodIndex)"
                            >
                              <td class="orders-table__name">
                                {{prod.name}}
                                <div v-if="getItemAdditionalInfo(prod)" class="pad-to-10"><span>{{$t('orders.custComments')}}: <i class="text-danger">{{getItemAdditionalInfo(prod)}}</i></span></div>
                                <div v-if="prod.comment_image"><a :href="prod.comment_image" target="_blank">{{$t('orders.seeImage')}}</a></div>
                                <div v-if="prod.created_at" class="orders-table__meta">{{ formatToCompanyTimezone(prod.created_at) }}</div>
                              </td>
                              <td>
                                <span v-if="getItemCategoryName(prod)">{{ getItemCategoryName(prod) }}</span>
                                <span v-else>-</span>
                              </td>
                              <td class="text-center">{{prod.quantity}}</td>
                              <td class="text-center">{{formatMoneyAmount(getItemUnitPrice(prod), currency)}}</td>
                              <td class="text-center">
                                <span class="order-item-discount-badge">{{formatMoneyAmount(prod.discount || 0, currency)}}</span>
                              </td>
                              <td class="text-center"><b>{{formatMoneyAmount(getProductOnlyLineTotal(prod), currency)}}</b></td>
                            </tr>
                            <tr
                              v-for="(opt, optIndex) in getItemOptions(prod)"
                              class="orders-table__option-row"
                              :class="{ 'orders-table__option-row--last': optIndex === getItemOptions(prod).length - 1 }"
                              :key="'o-' + (prod.id || prodIndex) + '-' + (opt.id || optIndex)"
                            >
                              <td class="orders-table__option-name">+ {{opt.name}}</td>
                              <td>-</td>
                              <td class="text-center">{{getOptionQuantity(opt)}}</td>
                              <td class="text-center">{{formatMoneyAmount(getOptionUnitPrice(opt), currency)}}</td>
                              <td class="text-center">
                                <span class="order-item-discount-badge">{{formatMoneyAmount(getOptionDiscount(opt), currency)}}</span>
                              </td>
                              <td class="text-center">{{formatMoneyAmount(getOptionLineTotal(prod, opt), currency)}}</td>
                            </tr>
                          </template>
                        </template>
                      </template><template v-else><tr></tr></template>

                      <tr v-if="(!order.is_split_pay && order.order_type=='GROUP') || (order.is_split_pay && customer.payment_type) || customer.is_open_order">
                        <td colspan="6">{{$t('customers.singleTotal')}} <b>{{formatMoneyAmount(customer.total_cart_price, currency)}}</b></td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <div class="clearfix"> </div>
                <div class="col-md-5 order-comment">
                  <!-- <h6><img class="pad-rg-5" src="/static/img/icons/comment.png">  {{$t('orders.custComments')}}</h6>
                  <hr class="sm">
                  {{order.comments ? order.comments : $t('orders.none')}} -->
                </div>
                <div class="col-md-7">
                  <table class="table no-border totals-table" v-if="order.status.id != 'OPEN_DRAFT'">
                    <tbody>
                      <template v-for="label of totals">
                        <template  v-if="(label != 'totals_grandtotal' || label != 'totals_shipping') && checkEmailTrnsport(order)">
                          <tr :class="getRowClass(label)" v-if="label == 'totals_grandtotal' || order[label] > 0">
                            <td>
                              <span v-if="label == 'SGR'">{{label}}</span>
                              <span v-if="label != 'totals_extras'">{{$t('orders.' + label)}}</span>
                              <span v-else-if="$t('orders.' + label + '_' + order.company_id) != 'orders.' + label + '_' + order.company_id">
                                {{$t('orders.' + label + '_' + order.company_id)}}
                              </span>
                              <span v-else>{{$t('orders.' + label)}}</span>
                              <span v-show="label == 'totals_discount'">(Coupon: {{coupon}})</span>
                            </td>
                            <td class="text-right">
                              {{formatMoneyAmount(order[label], currency, true)}}
                              <span v-if="editOrderFlag">
                                <button class="btn btn-default btn-icon" v-if="label == 'totals_grandtotal'" @click="editOrderPrice(order.id)">
                                  <i  class="fa fa-pencil"></i>
                                </button>
                                <div v-if="label == 'totals_grandtotal' && order.edit_order_history && order.edit_order_history.length">
                                  <small class="order_history_message">{{order.edit_order_history[0].reason}}</small>
                                </div>
                              </span>
                            </td>
                          </tr>
                          <template v-if="label === 'totals_subtotals'">
                            <tr v-for="tax in slotTaxes" :key="tax.id" :class="getRowClass('totals_extras')">
                              <td>{{tax.name}}</td>
                              <td class="text-right">
                                {{formatMoneyAmount(tax.tax_amount, currency, true)}}
                              </td>
                            </tr>
                          </template>
                        </template>
                      </template>
                      <template v-for="(sgrDetails, index) of order.sgr_totals">
                        <tr :class="getRowClass('totals_extras')" v-if="sgrDetails.value > 0">
                            <td>
                              <span>{{index}}</span>
                            </td>
                            <td class="text-right">
                              {{formatMoneyAmount(sgrDetails.value, currency, true)}}
                            </td>
                          </tr>
                      </template>
                      <tr :class="getRowClass('totals_grandtotal')">
                        <td>
                          <span>{{$t('orders.totals_grandtotal')}}</span>
                        </td>
                        <td class="text-right">
                          {{formatMoneyAmount(order['totals_grandtotal'], currency, true)}}
                          <span v-if="editOrderFlag">
                            <button class="btn btn-default btn-icon edit" @click="editOrderPrice(order.id)">
                              <i class="fa fa-pencil"></i>
                              {{$t('general.edit')}}
                            </button>
                            <div v-if="order.edit_order_history && order.edit_order_history.length">
                              <small class="order_history_message">{{order.edit_order_history[0].reason}}</small>
                            </div>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="clearfix"> </div>
              </div>
            </div>
          </div>
          <div class="clearfix"> </div>
          <div class="col-md-12 noprint">
            <div class="card">
              <div class="card-content">
                <h6><img class="pad-rg-5" src="/static/img/icons/commentClient-sm.png">  {{$t('orders.adminComments')}}</h6>
                <hr class="sm">
                <div class="form-group">
                  <textarea class="form-control" :placeholder="$t('orders.none')" rows="5" v-model="order.backoffice_comments"></textarea>
                </div>
                <div class="form-group">
                  <button class="btn btn-icon btn-success noprint save" @click.prevent="saveComment" :title="$t('general.save')">
                    <img src="/static/img/icons/save.png">
                    {{$t('general.save')}}
                  </button>
                </div>
              </div>
            </div>

          </div> <!-- end col-md-6  -->

          <div class="clearfix"> </div>
          <template v-if="order.payment_type === 'CARD_POS' && order.capture_transaction_response">
            <div class="col-md-12 col-print-12">
              <div class="card">
                <div class="card-content">
                  <h6><img class="pad-rg-5" src="/static/img/icons/pos_response.png">  {{$t('orders.pos_response_title')}}</h6>
                  <textarea class="form-control capture_transaction_response_string" disabled>{{capture_transaction_response_string}}</textarea>
                </div>
              </div>
            </div>
          </template>
          <div class="clearfix"> </div>
          <template v-if="order.receipt_number">
            <div class="col-md-12 col-print-12">
              <div class="card">
                <div class="card-content">
                  <h6><img class="pad-rg-5" src="/static/img/icons/pos_response.png">  {{$t('orders.fiscal_response_title')}}</h6>
                  <textarea class="form-control capture_transaction_response_string" disabled>{{receipt_number_string}}</textarea>
                </div>
              </div>
            </div>
          </template>

          <div class="clearfix"> </div>
          <template v-if="order.ep_restaurant_log">
            <div class="col-md-12 col-print-12">
              <div class="card">
                <div class="card-content">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="flex-space-between">
                        <h6><img class="pad-rg-5" src="/static/img/icons/comment.png">  {{$t('orders.orderNoArticulate')}}</h6>
                        <a class="btn btn-info btn-icon"  @click.prevent="sendOrderToEpRestaurant">
                          {{$t('marketingCampaigns.send')}}
                        </a>
                      </div>
                      <textarea class="form-control capture_transaction_response_string" disabled>{{order.ep_restaurant_log.data_to}}</textarea>
                    </div>
                    <div class="col-md-6">
                      <h6><img class="pad-rg-5" src="/static/img/icons/comment.png">  {{$t('feedback.response')}}</h6>
                      <textarea class="form-control capture_transaction_response_string" disabled>{{order.ep_restaurant_log.data_from}}</textarea>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <iframe id="print-frame" style="display:none;"></iframe>

    <vmodal name="paymentModal"
            title="paymentModal"
            class="paymentModal"
            width="70%"
            :maxWidth="800"
            :minWidth="700"
            height="400px"
            :adaptive="true"
      >
      <div class="header">
        <h2>{{$t('orders.type')}} {{$t('orders.payment')}}</h2>
      </div>
      <div class="content-order-view" >
        <div class="content_scrool">
          <div class="form-group">
            <label for="order_price">{{$t('orders.cui')}}</label>
            <input type="text" name="cui" class="form-control" v-model="cui" />
          </div>
        </div>
      </div>
      <template>
        <div class="paymentModal__footer">
          <button @click="processPrinter(1)" class="payment-type-button">{{$t('orders.cash')}}</button>
          <button @click="processPrinter(8)" class="payment-type-button">{{$t('orders.card_no_pos')}}</button>
          <button @click="processPrinter(2)" class="payment-type-button">{{$t('orders.card')}}</button>
          <button @click="processPrinter(7)" class="payment-type-button">{{$t('orders.online')}}</button>
          <button @click="processPrinter(11)" class="payment-type-button">{{$t('orders.GLOVO')}}</button>
          <button @click="processPrinter(12)" class="payment-type-button">{{$t('orders.BOLT')}}</button>
          <button @click="processPrinter(13)" class="payment-type-button">{{$t('orders.WOLT')}}</button>
          <button @click="closePaymentModal()" class="payment-type-button cancel-fiscal-print">{{$t('orders.cancel')}}</button>
        </div>
      </template>
    </vmodal>
    <vmodal name="editPriceModal"
          title="editPriceModal"
          class="editPriceModal"
          width="70%"
          height="65%"
          :maxWidth="800"
          :minWidth="200"
          :adaptive="true"
        >
        <div class="header border-bottom">
          <h4 >{{$t('general.edit')}}</h4>
        </div>
        <form>
          <div class="content-order-view" >
            <div class="content_scrool">
              <div class="form-group">
                <label for="order_price">{{$t('catalogProd.price')}}</label>
                <input type="text" name="order_price" class="form-control" v-validate="groupValidations.order_price" id="order_price" v-model="editOrder.price" />
                <small class="text-danger" v-if="errors.has('order_price')">
                  {{ getError('order_price') }}
                </small>
              </div>
              <div class="form-group">
                <label for="reason">{{$t('orders.cancelReason')}}</label>
                <textarea type="text" name="reason" class="form-control" id="reason" v-validate="groupValidations.reason" v-model="editOrder.reason"></textarea>
                <small class="text-danger" v-if="errors.has('reason')">
                  {{ getError('reason') }}
                </small>
              </div>
            </div>
          </div>
          <div class="editPriceModal__footer">
            <p class="d-inline-flex">
              <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" @click="$modal.hide('editPriceModal')" style="padding: 7px 10px; margin-right: 20px;">
                <img src="/static/img/icons/icon-close.png">
                {{$t('general.delete')}}
              </a>
              <button type="submit" class="btn btn-icon btn-success btn mar-rt-10 save"  @click.prevent="validate">
                <img src="/static/img/icons/save.png">
                {{$t('general.save')}}
              </button>
            </p>
          </div>
        </form>
    </vmodal>
  </div>
</template>
<script>
  import Vue from 'vue'
  import BtOrderPayment from 'src/mixins/BtOrderPayment'
  import {Select, Option, TimePicker, DatePicker, TimeSelect} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import moment from 'moment'
  import countriesList from './../Customers/countries'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import VueClipboard from 'vue-clipboard2'
  Vue.use(Select)
  Vue.use(DataTables)
  Vue.use(TimePicker)
  Vue.use(DatePicker)
  Vue.use(TimeSelect)
  Vue.use(VueClipboard)
  export default {
    mixins: [BtOrderPayment],
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [TimePicker.name]: TimePicker,
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect
    },
    props: {
      // callback: {
      //   required: true
      // },
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        capture_transaction_response_string: null,
        receipt_number_string: null,
        cui: null,
        classForBtn: '',
        order: [],
        coupon: '',
        countries: countriesList,
        modelValidations: {
          required: {
            required: true
          }
        },
        orderStatuses: [],
        currentOrdersStatus: 'NEW',
        usesExtraCosts: false,
        currency: '',
        timeFormat: this.getTimeFormat(),
        loading: true,
        refundLoading: false,
        locationId: null,
        showPrintBtn: false,
        totals: [
          'totals_subtotals',
          'totals_shipping',
          'totals_extras',
          'totals_tip',
          'totals_discount',
          'totals_discount_loyalty_points',
          'totals_donation'
        ],
        cancelOrder: null,
        grandchefDelay: 0,
        callPackageezConfig: null,
        editOrder: {
          price: 0,
          reason: ''
        },
        editOrderFlag: this.$session.get('selectedCompanyData')['edit_price'],
        groupValidations: {
          order_price: {
            required: true
          },
          reason: {
            required: true
          }
        },
        apiUrl: '',
        courierTime: null,
        jsonFields: {
          'Comandă ID': 'id',
          'Numar Comandă': 'number',
          'Client': 'client',
          'Telefon': 'phone',
          'Adresă': 'address',
          'Data livrare': 'delivery_date',
          'Comentariu': 'comment',
          'Nume produs': 'productName',
          'Cantitate': 'quantity',
          'Preț': 'price'
        },
        timezone: null
      }
    },
    created: function () {
      this.getData()
      this.onResize()
      this.getDefaults()
      this.apiUrl = process.env.API_BASE_URL
      window.addEventListener('resize', this.onResize)
      this.timezone = this.$session.get('selectedCompanyData').timezone || 'Europe/Bucharest'
    },
    computed: {
      slotTaxes () {
        return (this.order.order_taxes || []).filter(tax => {
          const type = Number(tax.type)
          return (type === 10 || type === 11) && !tax.deleted_at
        })
      },
      // Keep the existing EuPlatesc rule; BT returns require a verified transaction.
      canShowRefundButton () {
        const order = this.order
        if (!order || !order.status) {
          return false
        }
        return (
          order.payment_type === 'CARD' &&
          !!order.transaction_id &&
          (order.payment_id === 'btIpay' || (order.payment_id === 'euplatesc' && !!order.pay_link))
        )
      },
      // Already refunded / reversed -> keep the button visible but disabled and
      // relabeled, so it is obvious the refund was already handled.
      refundAlreadyDone () {
        const order = this.order
        if (!order) {
          return false
        }
        const status = order.capture_transaction_status
        return (
          order.is_refunded === 1 ||
          order.is_refunded === true ||
          status === 'reversal OK' ||
          status === 'refund OK'
        )
      },
      deliveryHeroStatus () {
        const order = this.order
        if (!order) return 0
        if (order.integration && order.integration.delivery_hero_status != null) {
          return Number(order.integration.delivery_hero_status)
        }
        if (order.delivery_hero_status != null) {
          return Number(order.delivery_hero_status)
        }
        return 0
      }
    },
    methods: {
      getPartItems (part) {
        if (part && part.order_part_items && part.order_part_items.length) {
          return part.order_part_items
        }
        return (part && part.items) || []
      },
      getItemCategoryName (item) {
        if (!item) return null
        if (item.category && item.category.name) return item.category.name
        return item.category_name || null
      },
      getItemOptions (item) {
        if (!item) return []
        if (item.options && item.options.length) return item.options
        if (item.item_options && item.item_options.length) return item.item_options
        return []
      },
      getItemAdditionalInfo (item) {
        if (!item) return ''
        return item.additional_info || item.comment || ''
      },
      getItemUnitPrice (item) {
        if (!item) return 0
        if (item.original_price_after_discount != null && item.original_price_after_discount !== '') {
          return parseFloat(item.original_price_after_discount) || 0
        }
        const price = parseFloat(item.price) || 0
        const discount = parseFloat(item.discount) || 0
        return price + discount
      },
      getItemFinalPrice (item) {
        if (!item) return 0
        return parseFloat(item.price) || 0
      },
      getItemOptionsTotal (item) {
        if (!item) return 0
        const options = this.getItemOptions(item)
        if (options.length) {
          return options.reduce((sum, opt) => {
            return sum + (this.getOptionQuantity(opt) * (parseFloat(opt.price) || 0))
          }, 0)
        }
        return parseFloat(item.options_total_price) || 0
      },
      getItemLineTotal (item) {
        if (!item) return 0
        const qty = parseFloat(item.quantity) || 0
        const unitTotal = parseFloat(item.price_total_product)
        if (!isNaN(unitTotal)) {
          return qty * unitTotal
        }
        return qty * (this.getItemFinalPrice(item) + this.getItemOptionsTotal(item))
      },
      getProductOnlyLineTotal (item) {
        if (!item) return 0
        const qty = parseFloat(item.quantity) || 0
        return qty * this.getItemFinalPrice(item)
      },
      getOptionUnitPrice (opt) {
        if (!opt) return 0
        if (opt.original_price_after_discount != null && opt.original_price_after_discount !== '') {
          return parseFloat(opt.original_price_after_discount) || 0
        }
        return (parseFloat(opt.price) || 0) + (parseFloat(opt.discount) || 0)
      },
      getOptionFinalPrice (opt) {
        return parseFloat(opt && opt.price) || 0
      },
      getOptionDiscount (opt) {
        return parseFloat(opt && opt.discount) || 0
      },
      getOptionQuantity (opt) {
        const qty = parseInt(opt && opt.quantity, 10)
        if (!isNaN(qty) && qty > 0) return qty
        return 1
      },
      formatOptionName (opt) {
        if (!opt) return ''
        const qty = this.getOptionQuantity(opt)
        const name = opt.name || ''
        if (qty > 1) {
          return `${qty} x ${name}`
        }
        return name
      },
      getOptionLineTotal (item, opt) {
        return this.getOptionQuantity(opt) * this.getOptionFinalPrice(opt)
      },
      formatToCompanyTimezone (value) {
        if (!value) return ''
        if (typeof value !== 'string') return String(value)

        const hasTimezone = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(value)
        const date = new Date(hasTimezone ? value : (value + 'Z'))
        if (Number.isNaN(date.getTime())) {
          return value
        }
        const formatter = new Intl.DateTimeFormat('en-GB', {
          timeZone: this.timezone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        })

        const parts = formatter.formatToParts(date)

        return `${parts.find(p => p.type === 'year').value}-${
          parts.find(p => p.type === 'month').value}-${
          parts.find(p => p.type === 'day').value} ${
          parts.find(p => p.type === 'hour').value}:${
          parts.find(p => p.type === 'minute').value}:${
          parts.find(p => p.type === 'second').value}`
      },
      getWoltDriveWebhookLogs (orderId) {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        swal({
          text: this.$t('general.generalLoader'),
          type: 'info',
          showConfirmButton: false,
          allowOutsideClick: false
        })

        this.apiRequest('/wolt-drive/order/' + orderId + '/webhook-logs', 'GET', data, (response) => {
          if (!response || response.status !== true) {
            swal({
              text: (response && (response.errors || response.message)) || this.$t('validations.wentWrong'),
              type: 'error',
              showConfirmButton: true
            })
            return
          }

          const trackingUrl = response.tracking_url || null
          const logs = Array.isArray(response.logs) ? response.logs : (response.logs ? [response.logs] : [])

          const escapeHtml = (value) => String(value == null ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')

          const getEventTypeKey = (eventType) => {
            if (!eventType || typeof eventType !== 'string') return null
            return 'orders.woltDriveEventType_' + eventType.replace(/\./g, '_')
          }

          const getEventTypeLabel = (eventType, statusValue) => {
            const key = getEventTypeKey(eventType)
            if (!key) return eventType || ''
            const label = this.$t(key)
            const base = label === key ? eventType : label
            if (eventType === 'order.status_updated' && statusValue) {
              return base + ': ' + statusValue
            }
            return base
          }

          const getActionLabel = (log) => {
            const action = (log && log.action) ? String(log.action) : ''
            const actionLower = action.toLowerCase()

            if (
              actionLower === 'get shipment promise (error)' ||
              actionLower === 'get shipment promise failed'
            ) {
              return this.$t('orders.woltDriveLogAction_Get_shipment_promise_failed')
            }

            if (actionLower === 'get shipment promise' || actionLower === 'get shipment promise (manual mode)') {
              return this.$t('orders.woltDriveLogAction_Get_shipment_promise')
            }

            if (actionLower.indexOf('cron callcourier company') === 0) {
              return this.$t('orders.woltDriveLogAction_Cron_callCourier')
            }

            if (actionLower === 'create delivery') {
              return this.$t('orders.woltDriveLogAction_Create_delivery')
            }

            if (actionLower === 'create delivery failed') {
              return this.$t('orders.woltDriveLogAction_Create_delivery_failed')
            }

            if (log && log.is_webhook_call) {
              return this.$t('orders.woltDriveLogAction_Webhook_event_received')
            }

            const meaningKey = 'orders.woltDriveLogAction_' + action
              .replace(/[()]/g, '')
              .replace(/\s*-\s*/g, '_')
              .replace(/\s+/g, '_')
              .replace(/_+/g, '_')
            const meaning = this.$t(meaningKey)
            if (meaning && meaning !== meaningKey) return meaning

            return action || '—'
          }

          const getResponseLabel = (log) => {
            const action = (log && log.action) ? String(log.action).toLowerCase() : ''
            const isShipmentPromise = action.indexOf('shipment promise') !== -1

            if (isShipmentPromise) {
              const isFailed = !!(log && log.is_error) ||
                action.indexOf('(error)') !== -1 ||
                action.indexOf('failed') !== -1

              if (isFailed) {
                const resp = (log && log.response && typeof log.response === 'object') ? log.response : {}
                const parts = []
                if (resp.error_code) parts.push(String(resp.error_code))
                if (resp.reason) parts.push(String(resp.reason))
                if (parts.length) return parts.join(' — ')
                const message = log && log.message != null ? String(log.message) : ''
                return message && message !== 'Success' ? message : ''
              }

              return this.$t('orders.woltDriveLogResponse_success')
            }

            if (log && log.is_webhook_call) {
              const eventType = (log.request && log.request.event_type) ||
                (log.response && log.response.type) || ''
              const statusValue = log.response && log.response.details && log.response.details.status
                ? log.response.details.status
                : ''
              if (eventType) return getEventTypeLabel(eventType, statusValue)
            }

            const message = log && log.message != null ? String(log.message) : ''
            if (message && message !== 'Success') return message

            if (log && log.tracking_id) return String(log.tracking_id)

            if (log && log.response != null) {
              if (typeof log.response === 'string') return log.response
              try {
                return JSON.stringify(log.response)
              } catch (e) {
                return String(log.response)
              }
            }

            return message || ''
          }

          const rows = logs.map((log) => {
            return {
              action: getActionLabel(log),
              response: getResponseLabel(log),
              createdAt: log && log.created_at ? this.formatToCompanyTimezone(log.created_at) : ''
            }
          })

          const html = rows.length
            ? '<div style="max-height: 420px; overflow-y: auto; padding-top: 6px;">' +
              '<table style="width: 100%; border-collapse: collapse; font-size: 14px;">' +
              '<thead>' +
              '<tr>' +
              '<th style="text-align: center; padding: 10px; border-bottom: 1px solid #e6e6e6;">' + this.$t('orders.woltDriveEventsEvent') + '</th>' +
              '<th style="text-align: center; padding: 10px; border-bottom: 1px solid #e6e6e6;">' + this.$t('orders.woltDriveLogResponse') + '</th>' +
              '<th style="text-align: center; padding: 10px; border-bottom: 1px solid #e6e6e6; white-space: nowrap;">' + this.$t('orders.woltDriveEventsTime') + '</th>' +
              '</tr>' +
              '</thead>' +
              '<tbody>' +
              rows.map((r) => {
                return '<tr>' +
                  '<td style="padding: 10px; border-bottom: 1px solid #f0f0f0; text-align: left;">' + escapeHtml(r.action) + '</td>' +
                  '<td style="padding: 10px; border-bottom: 1px solid #f0f0f0; text-align: left; word-break: break-word;">' + escapeHtml(r.response) + '</td>' +
                  '<td style="padding: 10px; border-bottom: 1px solid #f0f0f0; white-space: nowrap;">' + escapeHtml(r.createdAt) + '</td>' +
                  '</tr>'
              }).join('') +
              '</tbody>' +
              '</table>' +
              '</div>'
            : '<div style="padding: 24px; text-align: center;">' + this.$t('general.no_data') + '</div>'

          swal({
            title: this.$t('orders.woltDriveEvents'),
            html: html,
            width: '900px',
            showCancelButton: !!trackingUrl,
            cancelButtonText: '🔗 ' + this.$t('orders.woltDriveTrackCourier'),
            cancelButtonColor: '#007bff',
            confirmButtonText: 'OK',
            customClass: 'wolt-drive-events-swal'
          }).then(() => {}, (dismiss) => {
            if (dismiss === 'cancel' && trackingUrl) {
              window.open(trackingUrl, '_blank')
            }
          })
        })
      },
      getGlovoLaasWebhookLogs (orderId) {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        swal({
          text: this.$t('general.generalLoader'),
          type: 'info',
          showConfirmButton: false,
          allowOutsideClick: false
        })

        this.apiRequest('/glovo-laas/order/' + orderId + '/webhook-logs', 'GET', data, (response) => {
          if (!response || response.status !== true) {
            swal({
              text: (response && (response.errors || response.message)) || this.$t('validations.wentWrong'),
              type: 'error',
              showConfirmButton: true
            })
            return
          }

          const trackingUrl = response.tracking_url || null
          const logs = Array.isArray(response.logs) ? response.logs : (response.logs ? [response.logs] : [])

          const escapeHtml = (value) => String(value == null ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')

          const getEventTypeKey = (eventType) => {
            if (!eventType || typeof eventType !== 'string') return null
            return 'orders.glovoLaasEventType_' + eventType.replace(/\./g, '_')
          }

          const getEventTypeLabel = (eventType, statusValue) => {
            const key = getEventTypeKey(eventType)
            if (!key) return eventType || ''
            const label = this.$t(key)
            const base = label === key ? eventType : label
            if (statusValue) {
              return base + ': ' + statusValue
            }
            return base
          }

          const getActionLabel = (log) => {
            const action = (log && log.action) ? String(log.action) : ''
            const actionLower = action.toLowerCase()

            if (actionLower === 'create delivery' || actionLower === 'create order') {
              return this.$t('orders.glovoLaasLogAction_Create_delivery')
            }

            if (actionLower === 'create delivery failed' || actionLower === 'create order failed') {
              return this.$t('orders.glovoLaasLogAction_Create_delivery_failed')
            }

            if (actionLower === 'cancel delivery' || actionLower === 'cancel order') {
              return this.$t('orders.glovoLaasLogAction_Cancel_delivery')
            }

            if (actionLower.indexOf('cron callcourier company') === 0) {
              return this.$t('orders.glovoLaasLogAction_Cron_callCourier')
            }

            if (log && log.is_webhook_call) {
              return this.$t('orders.glovoLaasLogAction_Webhook_event_received')
            }

            const meaningKey = 'orders.glovoLaasLogAction_' + action
              .replace(/[()]/g, '')
              .replace(/\s*-\s*/g, '_')
              .replace(/\s+/g, '_')
              .replace(/_+/g, '_')
            const meaning = this.$t(meaningKey)
            if (meaning && meaning !== meaningKey) return meaning

            return action || '—'
          }

          const getResponseLabel = (log) => {
            if (log && log.is_webhook_call) {
              const eventType = (log.request && log.request.event_type) ||
                (log.request && log.request.type) ||
                (log.response && log.response.type) ||
                (log.response && log.response.event_type) || ''
              const statusValue = log.response && log.response.details && log.response.details.status
                ? log.response.details.status
                : (log.response && log.response.status ? log.response.status : '')
              if (eventType) return getEventTypeLabel(eventType, statusValue)
            }

            const message = log && log.message != null ? String(log.message) : ''
            if (message && message !== 'Success') return message

            if (log && log.tracking_id) return String(log.tracking_id)

            if (log && log.response != null) {
              if (typeof log.response === 'string') return log.response
              try {
                return JSON.stringify(log.response)
              } catch (e) {
                return String(log.response)
              }
            }

            return message || ''
          }

          const rows = logs.map((log) => {
            return {
              action: getActionLabel(log),
              response: getResponseLabel(log),
              createdAt: log && log.created_at ? this.formatToCompanyTimezone(log.created_at) : ''
            }
          })

          const html = rows.length
            ? '<div style="max-height: 420px; overflow-y: auto; padding-top: 6px;">' +
              '<table style="width: 100%; border-collapse: collapse; font-size: 14px;">' +
              '<thead>' +
              '<tr>' +
              '<th style="text-align: center; padding: 10px; border-bottom: 1px solid #e6e6e6;">' + this.$t('orders.glovoLaasEventsEvent') + '</th>' +
              '<th style="text-align: center; padding: 10px; border-bottom: 1px solid #e6e6e6;">' + this.$t('orders.glovoLaasLogResponse') + '</th>' +
              '<th style="text-align: center; padding: 10px; border-bottom: 1px solid #e6e6e6; white-space: nowrap;">' + this.$t('orders.glovoLaasEventsTime') + '</th>' +
              '</tr>' +
              '</thead>' +
              '<tbody>' +
              rows.map((r) => {
                return '<tr>' +
                  '<td style="padding: 10px; border-bottom: 1px solid #f0f0f0; text-align: left;">' + escapeHtml(r.action) + '</td>' +
                  '<td style="padding: 10px; border-bottom: 1px solid #f0f0f0; text-align: left; word-break: break-word;">' + escapeHtml(r.response) + '</td>' +
                  '<td style="padding: 10px; border-bottom: 1px solid #f0f0f0; white-space: nowrap;">' + escapeHtml(r.createdAt) + '</td>' +
                  '</tr>'
              }).join('') +
              '</tbody>' +
              '</table>' +
              '</div>'
            : '<div style="padding: 24px; text-align: center;">' + this.$t('general.no_data') + '</div>'

          swal({
            title: this.$t('orders.glovoLaasEvents'),
            html: html,
            width: '900px',
            showCancelButton: !!trackingUrl,
            cancelButtonText: '🔗 ' + this.$t('orders.glovoLaasTrackCourier'),
            cancelButtonColor: '#007bff',
            confirmButtonText: 'OK',
            customClass: 'wolt-drive-events-swal'
          }).then(() => {}, (dismiss) => {
            if (dismiss === 'cancel' && trackingUrl) {
              window.open(trackingUrl, '_blank')
            }
          })
        })
      },
      getDeliveryHeroWebhookLogs (orderId) {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        swal({
          text: this.$t('general.generalLoader'),
          type: 'info',
          showConfirmButton: false,
          allowOutsideClick: false
        })

        this.apiRequest('/delivery-hero/order/' + orderId + '/webhook-logs', 'GET', data, (response) => {
          if (!response || response.status !== true) {
            swal({
              text: (response && (response.errors || response.message)) || this.$t('validations.wentWrong'),
              type: 'error',
              showConfirmButton: true
            })
            return
          }

          const logs = Array.isArray(response.logs) ? response.logs : (response.logs ? [response.logs] : [])

          const escapeHtml = (value) => String(value == null ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')

          const getActionLabel = (log) => {
            const action = (log && log.action) ? String(log.action) : ''
            const actionLower = action.toLowerCase()

            if (actionLower === 'create order' || actionLower === 'create delivery') {
              return this.$t('orders.deliveryHeroLogAction_Create_order')
            }
            if (actionLower.indexOf('create order failed') === 0 || actionLower.indexOf('create delivery failed') === 0) {
              return this.$t('orders.deliveryHeroLogAction_Create_order_failed')
            }
            if (actionLower === 'cancel order' || actionLower === 'cancel delivery') {
              return this.$t('orders.deliveryHeroLogAction_Cancel_order')
            }
            if (actionLower.indexOf('cancel order failed') === 0) {
              return this.$t('orders.deliveryHeroLogAction_Cancel_order_failed')
            }
            if (actionLower === 'oauth token' || actionLower.indexOf('oauth') === 0) {
              return this.$t('orders.deliveryHeroLogAction_OAuth_token')
            }
            if (actionLower === 'status webhook' || (log && log.is_webhook_call && actionLower.indexOf('refund') < 0)) {
              return this.$t('orders.deliveryHeroLogAction_Status_webhook')
            }
            if (actionLower === 'refund webhook' || actionLower.indexOf('refund') >= 0) {
              return this.$t('orders.deliveryHeroLogAction_Refund_webhook')
            }
            if (actionLower === 'autopilot skip') {
              return this.$t('orders.deliveryHeroLogAction_Autopilot_skip')
            }

            const meaningKey = 'orders.deliveryHeroLogAction_' + action
              .replace(/[()]/g, '')
              .replace(/\s*-\s*/g, '_')
              .replace(/\s+/g, '_')
              .replace(/_+/g, '_')
            const meaning = this.$t(meaningKey)
            if (meaning && meaning !== meaningKey) return meaning

            return action || '—'
          }

          const getResponseLabel = (log) => {
            if (log && log.odr_order_id) {
              const from = log.data_from
              if (from != null) {
                if (typeof from === 'string') return from
                try {
                  return JSON.stringify(from)
                } catch (e) {
                  return String(from)
                }
              }
              return String(log.odr_order_id)
            }

            if (log && log.data_from != null) {
              if (typeof log.data_from === 'string') return log.data_from
              try {
                return JSON.stringify(log.data_from)
              } catch (e) {
                return String(log.data_from)
              }
            }

            return ''
          }

          const rows = logs.map((log) => {
            return {
              action: getActionLabel(log),
              response: getResponseLabel(log),
              createdAt: log && log.created_at ? this.formatToCompanyTimezone(log.created_at) : ''
            }
          })

          const html = rows.length
            ? '<div style="max-height: 420px; overflow-y: auto; padding-top: 6px;">' +
              '<table style="width: 100%; border-collapse: collapse; font-size: 14px;">' +
              '<thead>' +
              '<tr>' +
              '<th style="text-align: center; padding: 10px; border-bottom: 1px solid #e6e6e6;">' + this.$t('orders.deliveryHeroEventsEvent') + '</th>' +
              '<th style="text-align: center; padding: 10px; border-bottom: 1px solid #e6e6e6;">' + this.$t('orders.deliveryHeroLogResponse') + '</th>' +
              '<th style="text-align: center; padding: 10px; border-bottom: 1px solid #e6e6e6; white-space: nowrap;">' + this.$t('orders.deliveryHeroEventsTime') + '</th>' +
              '</tr>' +
              '</thead>' +
              '<tbody>' +
              rows.map((r) => {
                return '<tr>' +
                  '<td style="padding: 10px; border-bottom: 1px solid #f0f0f0; text-align: left;">' + escapeHtml(r.action) + '</td>' +
                  '<td style="padding: 10px; border-bottom: 1px solid #f0f0f0; text-align: left; word-break: break-word;">' + escapeHtml(r.response) + '</td>' +
                  '<td style="padding: 10px; border-bottom: 1px solid #f0f0f0; white-space: nowrap;">' + escapeHtml(r.createdAt) + '</td>' +
                  '</tr>'
              }).join('') +
              '</tbody>' +
              '</table>' +
              '</div>'
            : '<div style="padding: 24px; text-align: center;">' + this.$t('general.no_data') + '</div>'

          swal({
            title: this.$t('orders.deliveryHeroEvents'),
            html: html,
            width: '900px',
            showCancelButton: false,
            confirmButtonText: 'OK',
            customClass: 'wolt-drive-events-swal'
          })
        })
      },
      printToIframe () {
        const iframe = document.getElementById('print-frame')
        const doc = iframe.contentWindow.document

        let ordersHtml = ''
        const partsHtml = this.order.parts.map(part => {
          const productMap = new Map()

          // Step 1: Aggregate products
          this.getPartItems(part).forEach(prod => {
            const optionsKey = this.getItemOptions(prod).map(opt => opt.name).join('|')
            const infoKey = this.getItemAdditionalInfo(prod) || ''
            const key = `${prod.name}||${optionsKey}||${infoKey}`

            if (productMap.has(key)) {
              productMap.get(key).quantity += prod.quantity
            } else {
              productMap.set(key, {
                name: prod.name,
                quantity: prod.quantity,
                options: this.getItemOptions(prod),
                additional_info: this.getItemAdditionalInfo(prod)
              })
            }
          })

          // Step 2: Build HTML from merged products
          const itemsHtml = Array.from(productMap.values()).map(prod => {
            const itemOptions = this.getItemOptions(prod)
            const optionsHtml = itemOptions.length
              ? `<div class="options">${itemOptions.map(opt =>
                  `+ ${this.formatOptionName(opt)}`
                ).join('<br>')}</div>`
              : ''
            const infoHtml = this.getItemAdditionalInfo(prod)
              ? `<div class="options">- ${this.getItemAdditionalInfo(prod)}</div>`
              : ''

            return `
              <tr>
                <td>
                  ${prod.name}
                  ${optionsHtml}
                  ${infoHtml}
                </td>
                <td class="center">${prod.quantity}</td>
              </tr>
            `
          }).join('')

          return `
            ${this.order.order_type === 'GROUP' ? `<div class="section"><b>Sub-client:</b> ${part.customer_name}</div>` : ''}
            <table>
              <thead>
                <tr>
                  <th>Nume</th>
                  <th>Cantitate</th>
                </tr>
              </thead>
              <tbody>
                ${itemsHtml}
              </tbody>
            </table>
          `
        }).join('')

        ordersHtml += `
          <div class="card">
            <div class="section"><b>Comanda:</b> ${parseInt(this.order.number)} - ${this.order.id}</div>
            <div class="section"><b>Client:</b> ${this.order.delivery_details_firstname} | ${this.order.delivery_details_phone}</div>
            ${this.order.address_shipping ? `
              <div class="section">
                <b>Adresa:</b>
                ${this.order.address_shipping.state || ''},
                ${this.order.address_shipping.city || ''},
                ${this.order.address_shipping.street || ''} ${this.order.address_shipping.number || ''},
                ${this.order.address_shipping.apartment || ''}
                ${this.order.address_shipping.other_info || ''}
              </div>` : ''}
            ${this.order.pickup_datetime ? `<div class="section"><b>Data livrare:</b> ${this.order.pickup_datetime.split(' ')[0]}</div>` : ''}
            ${this.order.customer.comment ? `<div class="section"><b>Comentariu:</b> ${this.order.customer.comment}</div>` : ''}
            ${partsHtml}
          </div>
        `

        const content = `
          <html>
            <head>
              <title>Comanda #${parseInt(this.order.number)} - ${parseInt(this.order.id)}</title>
              <style>
                * {
                  box-sizing: border-box;
                }
                body {
                  font-family: sans-serif;
                  padding: 10px;
                  margin: 0;
                  font-size: 16px;
                }
                .card {
                  border: 1px solid #aaa;
                  border-radius: 6px;
                  padding: 8px;
                  margin-bottom: 12px;
                  width: 100%;
                  page-break-inside: avoid;
                }
                .section {
                  margin-bottom: 6px;
                }
                .section b {
                  display: inline;
                  font-weight: bold;
                  margin-right: 4px;
                }
                table {
                  width: 100%;
                  border-collapse: collapse;
                  margin-top: 5px;
                }
                th, td {
                  border: 1px solid #ccc;
                  padding: 2px 4px;
                  font-size: 16px;
                  word-break: break-word;
                }
                td.center {
                  text-align: center;
                }
                .options {
                  font-size: 14px;
                  color: #555;
                }
              </style>
            </head>
            <body>
              ${ordersHtml}
            </body>
          </html>
        `

        doc.open()
        doc.write(content)
        doc.close()
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
      },
      orderExportData () {
        const order = this.order
        if (!order || !order.parts) return []

        const base = {
          id: `${order.id || ''}`,
          number: `${parseInt(order.number) || ''}`,
          client: `${order.delivery_details_firstname || ''}`,
          phone: `${order.delivery_details_phone || ''}`,
          address: order.address_shipping
            ? `${order.address_shipping.state || ''}, ${order.address_shipping.city || ''}, ${order.address_shipping.street || ''} ${order.address_shipping.number || ''}, ${order.address_shipping.apartment || ''} ${order.address_shipping.details || ''}`.trim()
            : '',
          delivery_date: order.pickup_datetime.split(' ')[0] || '',
          comment: order.customer.comment || ''
        }

        const productMap = new Map()

        order.parts.forEach(part => {
          this.getPartItems(part).forEach(prod => {
            const productName = (() => {
              let name = prod.name || ''
              const options = this.getItemOptions(prod).map(opt => `+ ${this.formatOptionName(opt)}${opt.price ? ` (${opt.price})` : ''}`).join(', ') || ''
              const info = this.getItemAdditionalInfo(prod) ? ` - ${this.getItemAdditionalInfo(prod)}` : ''
              return `${name}${options ? ' - ' + options : ''}${info}`
            })()

            const key = productName

            if (productMap.has(key)) {
              const existing = productMap.get(key)
              existing.quantity += prod.quantity
            } else {
              productMap.set(key, {
                ...base,
                productName,
                quantity: prod.quantity,
                price: prod.price
              })
            }
          })
        })

        return Array.from(productMap.values())
      },
      generateProductsData (parts) {
        let products = ''
        parts.forEach(part => {
          this.getPartItems(part).forEach(prod => {
            const options = this.getItemOptions(prod).map(opt => `+ ${this.formatOptionName(opt)}${opt.price ? ` (${opt.price})` : ''}`).join(', ') || ''
            const info = this.getItemAdditionalInfo(prod) ? ` - ${this.getItemAdditionalInfo(prod)}` : ''
            products += `${prod.name}${options ? ' - ' + options : ''}${info} | Cantitate: ${prod.quantity} | Preț: ${prod.price}\n`
          })
        })

        return products.trim()
      },
      startDownload () {
        this.loading = true
      },
      finishDownload () {
        this.loading = false
      },
      printReceipt () {
        const printWindow = window.open('', '_blank')

        /* eslint-disable */
        const htmlContent = `
          <html>
            <head>
              <title>Print Receipt</title>
              <style>
                body { font-family: sans-serif; padding: 20px; }
                .no-print { display: none !important; }
              </style>
            </head>
            <body>
              <div id="printable">
                <h1>Receipt</h1>
                <p>Total: $123.45</p>
              </div>
              <script>
                window.onload = function() {
                  window.print();
                  window.close();
                };
              <\/script>
            </body>
          </html>
        `;
        /* eslint-enable */

        printWindow.document.open()
        printWindow.document.write(htmlContent)
        printWindow.document.close()
      },
      showExpressoftError () {
        let data = {
          id: this.route.params.id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/show-expressoft-log', 'GET', data, (response) => {
          if (response.status) {
            swal({
              title: 'Expressoft Log',
              icon: 'error',
              html: response.data.log,
              showCloseButton: true
            })
          }
        })
      },
      sendOrderToEpRestaurant () {
        this.loading = true
        let data = {
          token: this.$session.get('token')
        }
        swal({
          type: 'question',
          text: this.$t('epRestaurant.resendQuestion'),
          position: 'top-end',
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes'),
          cancelButtonText: this.$t('general.no'),
          allowOutsideClick: false
        }).then((result) => {
          this.apiRequest('/ep-restaurant/send-order/' + this.route.params.id, 'POST', data, (response) => {
            if (response) {
              this.loading = false
              swal({
                text: this.$t('orders.orderSentSuccess'),
                type: 'success',
                showConfirmButton: false
              })
              this.getData()
            }
          })
        }, (dismiss) => {
          this.loading = false
        })
      },
      editOrderNow () {
        // window.open('/#/add-order?order_id=' + this.order.id, '_blank')
        this.$router.push('/add-order/?order_id=' + this.order.id)
        this.backButton()
      },
      async downloadImage (imageSrc, name) {
        const image = await fetch(imageSrc)
        const imageBlog = await image.blob()
        const imageURL = URL.createObjectURL(imageBlog)

        const link = document.createElement('a')
        link.href = imageURL
        link.download = name
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      },
      emitInvoice () {
        let data = {
          id: this.route.params.id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        this.apiRequest('/send-order-invoice', 'POST', data, (response) => {
          if (response) {
            swal({
              // text: this.$t('orders.orderSentSuccess'),
              text: response.message,
              type: 'info',
              // timer: 1000,
              showConfirmButton: true
            })
            this.getData()
          }
        })
      },
      deliveredStatusValidation (sts) {
        let isDisabled = ((this.order.status.id === 'DELIVERED' || this.order.status.id === 'NOT_DELIVERED') &&
          (sts.type !== 'CANCELED' && sts.type !== 'DELIVERED' && sts.type !== 'NOT_DELIVERED')) ||
          (this.order.status.id === 'PREPARED' && (sts.type === 'PROCESSING' || sts.type === 'NEW' || sts.type === 'ON_HOLD' || sts.type === 'POSTPONE')) ||
          (this.order.status.id === 'TRANSPORT' && (sts.type === 'PREPARED' || sts.type === 'PROCESSING' || sts.type === 'NEW' || sts.type === 'ON_HOLD' || sts.type === 'POSTPONE'))
        return isDisabled
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          // this.$emit('on-submit', this.registerForm, isValid)
          if (isValid) {
            this.errors.clear()
            this.updateOrderPrice()
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            this.errors.add(prop, errors[prop])
          }
        }
      },
      checkEmailTrnsport (order) {
        if (this.$session.get('userDataRole') === 'USER' || this.$session.get('userDataRole') === 'LOCATION_STORE_ADMIN') {
          if (order.email_transport) {
            return false
          }
        }
        return true
      },
      onResize () {
        if (window.innerWidth <= 1200) {
          this.classForBtn = 'mb40'
        } else {
          this.classForBtn = ''
        }
      },
      getRowClass (label) {
        switch (label) {
          case 'totals_discount_loyalty_points':
          case 'totals_discount':
            return 'text-danger'
          case 'totals_grandtotal': return 'text-bold total-row'
          default: return ''
        }
      },
      isNew () {
        if (this.route.params.id) {
          return false
        } else {
          return true
        }
      },
      disabledCls (isBefore) {
        if (isBefore) {
          return 'disabled'
        } else {
          return ''
        }
      },
      getPaymetnStatus (status) {
        if (this.order.payment_id === 'btIpay' && status === 'AUTHORIZED') {
          return ' - <span class="text-info">' + this.$t('btPayments.authorized') + '</span>'
        }
        switch (status) {
          // case null:
          //   return this.$t('paymentStatus.notPaid')
          case 'OK':
            return ' - <span class="text-success">' + this.$t('paymentStatus.paid') + '</span>'
          case 'NOT OK':
            return ' - <span class="text-danger">' + this.$t('paymentStatus.notOk') + '</span>'
          default:
            return ' - <span class="text-warning">' + this.$t('paymentStatus.notPaid') + '</small></span> <br><span class="text-muted"><small>' + this.$t('paymentStatus.notPaidDetails') + '</small></span>'
        }
      },
      // Pull the most meaningful text out of an apiRequest response. On a non-2xx
      // reply the mixin resolves to { status: false, error: <axiosError> }, so the
      // API's JSON body (with its `message`) lives under error.response.data.
      refundErrorMessage (response) {
        if (response) {
          if (response.error && response.error.response && response.error.response.data) {
            const data = response.error.response.data
            if (data.message) {
              return data.message
            }
            if (data.error) {
              return data.error
            }
          }
          if (response.message) {
            return response.message
          }
        }
        return this.$t('orders.refundError')
      },
      doRefundOrder () {
        var self = this
        if (this.refundAlreadyDone || this.refundLoading || this.btReturnPending) {
          return
        }
        swal({
          title: self.$t('orders.refundConfirmTitle'),
          text: self.$t(self.order.payment_id === 'btIpay' ? 'btPayments.refundConfirm' : 'orders.refundConfirmText'),
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: self.$t('general.cancel'),
          confirmButtonText: self.$t('orders.refundOrder')
        }).then((result) => {
          if (!result) {
            return
          }
          var id = self.route.params.id
          var data = {
            token: self.$session.get('token'),
            company_id: self.$session.get('selectedCompany'),
            order_id: parseInt(id)
          }
          self.refundLoading = true
          self.loading = true
          self.apiRequest('/refound-order', 'POST', data, function (response) {
            self.refundLoading = false
            self.loading = false
            if (response && response.success === true) {
              if (self.order.payment_id === 'btIpay' && response.pending === true) {
                self.handleBtReturnQueued()
                return
              }
              swal({
                title: '',
                text: response.message || self.$t('orders.refundSuccess'),
                type: 'success'
              }).then(() => {
                self.afterRefundSuccess(id)
              }).catch(() => {
                self.afterRefundSuccess(id)
              })
            } else {
              swal({
                title: '',
                text: self.refundErrorMessage(response),
                type: 'error'
              })
            }
          })
        }).catch(() => {})
      },
      afterRefundSuccess (id) {
        var self = this
        // Refresh the order (updates is_refunded / status buttons) and the list.
        self.$session.set('refreshOrdersCount', 'refresh')
        self.getData()
        self.$bus.$emit('refresh', id)
        // If the order is not cancelled yet, offer to cancel it now. On confirm we
        // cancel WITHOUT the legacy automat-refund step (money was already returned).
        if (!self.order || !self.order.status || self.order.status.id === 'CANCELED') {
          return
        }
        swal({
          title: '',
          text: self.$t('orders.refundAskCancel'),
          type: 'question',
          showCancelButton: true,
          cancelButtonText: self.$t('general.cancel')
        }).then((result) => {
          if (result) {
            self.cancelAfterRefund(id)
          }
        }).catch(() => {})
      },
      cancelAfterRefund (id) {
        var self = this
        var data = {
          id: id,
          token: self.$session.get('token'),
          company_id: self.$session.get('selectedCompany'),
          status: 'CANCELED'
        }
        self.apiRequest('/order/' + id, 'PUT', data, function (response) {
          if (response.status === true) {
            self.$session.set('refreshOrdersCount', 'refresh')
            if (self.$bus) {
              self.$bus.$emit('stopSound')
              self.$bus.$emit('refresh', id)
            }
            swal({
              text: self.$t('orders.orderStatusSuccess'),
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            })
            self.getData()
          } else if (response.errors && response.errors.boogit) {
            swal({
              text: response.errors.boogit,
              type: 'error',
              showConfirmButton: false,
              timer: 1500
            })
          } else {
            swal('', self.$t('validations.wentWrong'), 'error')
          }
        })
      },
      showPrint () {
        let show = false
        let companyLocations = this.$session.get('selectedCompanyData')
        if (this.order.production_details) {
          let locationId = this.order.production_details.location.id
          for (let location of companyLocations.locations_details) {
            if (location.id === locationId && location.use_printer !== undefined && location.use_printer) {
              show = true
            }
          }
        }
        return show
      },
      showDrCarmen () {
        let companyLocations = this.$session.get('selectedCompanyData')
        let locationId = this.order.production_details.location.id
        let show = false
        for (let location of companyLocations.locations_details) {
          if (location.id === locationId && location.drcarmen_active !== undefined && location.drcarmen_active) {
            show = true
          }
        }
        return show
      },
      getData () {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        // get product data
        if (this.route.params.id) {
          var id = this.route.params.id

          this.apiRequest('/order/' + id, 'GET', data, (response) => {
            if (response.status === true) {
              if (this.route.query.print_fiscal) {
                this.printFiscal()
              }
              response.data[0].formatted_pickup_datetime = this.formatTime(response.data[0].pickup_datetime)
              response.data[0].formatted_date_pickup_datetime = this.formatDate(response.data[0].pickup_datetime)
              this.order = response.data[0]
              if (this.order.capture_transaction_response && this.order.payment_type === 'CARD_POS') {
                this.order.capture_transaction_response = JSON.parse(this.order.capture_transaction_response)
                this.capture_transaction_response_string = JSON.stringify(this.order.capture_transaction_response, null, 1)
                // this.capture_transaction_response_string = ''
                // Object.values(this.order.capture_transaction_response).forEach(val => {
                //   this.capture_transaction_response_string += val.tag + ': ' + val.resp_ascii + '\n'
                //   // this.capture_transaction_response.push({
                //   //   'tag': val.tag,
                //   //   'resp_ascii': val.resp_ascii
                //   // })
                // })
              }
              if (this.isJSONString(this.order.receipt_number)) {
                this.order.receipt_number = JSON.parse(this.order.receipt_number)
                this.receipt_number_string = JSON.stringify(this.order.receipt_number, null, 1)
              } else {
                this.order.receipt_number = null
                this.receipt_number_string = null
              }
              this.coupon = this.order.coupon
              if (this.order.applyCoupons) {
                this.coupon = ''
                for (let cupons in this.order.applyCoupons) {
                  if (this.order.applyCoupons[cupons].coupon_has_multiple_codes) {
                    this.coupon += this.order.applyCoupons[cupons].selected_coupon_code
                  } else {
                    this.coupon += this.order.applyCoupons[cupons].coupon_code
                  }
                  this.coupon += ', '
                }
                this.coupon = this.coupon.slice(0, -2)
              }
              for (var iParts in this.order.parts) {
                const part = this.order.parts[iParts]
                const partItems = this.getPartItems(part)
                for (var iItem in partItems) {
                  let item = partItems[iItem]
                  const sumOptions = this.getItemOptionsTotal(item)
                  item.price_total_product = (this.getItemFinalPrice(item) + sumOptions).toFixed(2)
                }
              }
              let companyLocations = this.$session.get('selectedCompanyData')
              let statusesRaw = this.$session.get('defaultData')['order_statuses']
              var isBefore = true
              var isAllowed = true
              if (this.order.hio_flag) {
                this.cancelOrder = this.order.hio_status
              }
              if (this.order.packageez_flag) {
                this.cancelOrder = !!this.order.packagez_order_id
              }
              if (this.order.rapid_donkey_status === 2) {
                this.cancelOrder = true
              }
              if (this.order.glovo_status === 2) {
                this.cancelOrder = true
              }
              // self.cancelOrder = self.order.hio_status ? self.order.hio_status : !!self.order.packagez_order_id
              // self.cancelOrder = self.order.hio_status
              this.orderStatuses = []
              this.currentOrdersStatus = this.order.status.id
              // there is no need to loop through all the delivery methods for 1 order.
              // for (var ordType in statusesRaw) {
              for (var type in statusesRaw[this.order.delivery_type]) {
                if (type !== 'DRAFT') {
                  if (type === 'CANCELED' && this.order.payment_type === 'CARD' && this.order.capture_transaction_status === 'OK') {
                    isAllowed = false
                  } else if (this.order.delivery_type === 'EAT_LOCATION') {
                    isAllowed = true
                  } else {
                    isAllowed = this.orderStatusAllowed(this.order.status.id, type)
                  }
                  if (this.order.status.id === type) {
                    isBefore = false
                  }
                  if (type !== 'ON_HOLD' || (type === 'ON_HOLD' && companyLocations.is_allowed_on_hold)) {
                    if (type !== 'POSTPONED' || (type === 'POSTPONED' && companyLocations.is_allowed_postponed)) {
                      this.orderStatuses.push({
                        'type': type,
                        'text': statusesRaw[this.order.delivery_type][type],
                        'isBefore': isBefore,
                        'isAllowed': isAllowed
                      })
                    }
                  }
                }
              }
              // }
              Vue.set(this, 'currency', response.data[0]['currency'])

              this.showPrintBtn = this.showPrint()
            }
            this.loading = false
          })
        }
      },
      getDefaults () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/listdefaults', 'GET', data, (response) => {
          if (response.status === true) {
            this.callPackageezConfig = response.data[0].call_packageez_courier_on_processing
          }
        })
      },
      callPackageezOnProcessing () {
        let compnayId = this.$session.get('selectedCompany')
        if (this.callPackageezConfig && this.callPackageezConfig[compnayId]) {
          var id = this.route.params.id
          var data = {
            token: this.$session.get('token'),
            company_id: compnayId,
            id: id,
            location_id: this.order.store_id,
            time: this.callPackageezConfig[compnayId]['time'],
            size: this.callPackageezConfig[compnayId]['size']
          }
          this.apiRequest('/packagez-send-order', 'POST', data, (response) => {
            if (response.status === true) {
              swal({
                text: this.$t('orders.orderSentSuccess'),
                type: 'success',
                timer: 1000,
                showConfirmButton: false
              })
              this.cancelOrder = true
            } else {
              swal({
                text: this.$t('orders.contactPakageez'),
                type: 'error',
                timer: 2000,
                showConfirmButton: false
              })
            }
          })
        }
      },
      heartbeat (orderData) {
        // console.warn(' ------ heart beat on single order ---------')
        var self = this
        self.order.status = orderData.status

        // let statusesRaw = self.$session.get('defaultData')['order_statuses']
        // var isBefore = true
        // var isAllowed = true
        self.currentOrdersStatus = self.order.status.id

        // There is no need to repopulate orderStatuses
        // self.orderStatuses = []

        // for (var ordType in statusesRaw) {
        //   for (var type in statusesRaw[ordType]) {
        //     if (ordType === self.order.delivery_type && type !== 'DRAFT') {
        //       isAllowed = self.orderStatusAllowed(self.order.status.id, type)
        //        CHECK IF COMPANY IS ALLOWED TO USE ON_HOLD AND POSTPONED
        //       self.orderStatuses.push({
        //         'type': type,
        //         'text': statusesRaw[ordType][type],
        //         'isBefore': isBefore,
        //         'isAllowed': isAllowed
        //       })
        //       if (self.order.status.id === type) {
        //         isBefore = false
        //       }
        //     }
        //   }
        // }
        this.$nextTick(() => {
          // trigger next tick
        })
      },
      updateHour () {
        var id = this.route.params.id
        if (this.order.formatted_pickup_datetime === '' || this.order.formatted_pickup_datetime === null) {
          swal({'text': self.$t('orders.orderHourError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch({})
        } else {
          var newTime = moment(String(this.order.pickup_datetime)).format('YYYY-MM-DD')
          newTime = moment(String(newTime + ' ' + this.order.formatted_pickup_datetime)).format('YYYY-MM-DD HH:mm:ss')
          var data = {
            id: id,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            pickup_datetime: newTime
          }
          // console.warn(data)
          this.apiRequest('/order/' + id, 'PUT', data, (response) => {
            // console.warn(response)
            if (response.status === true) {
              swal(
                '',
                this.$t('orders.orderHourSuccess'),
                'success'
              )
            } else {
              swal(
                '',
                this.$t('validations.wentWrong'),
                'error'
              )
            }
          })
        }
      },
      automatUpdateHour (time, flag) {
        var id = this.route.params.id
        var self = this
        if (this.order.formatted_pickup_datetime === '' || this.order.formatted_pickup_datetime === null) {
          swal({'text': self.$t('orders.orderHourError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch({})
        } else {
          var newTime = moment(String(this.order.pickup_datetime)).format('YYYY-MM-DD')
          if (flag === 'add') {
            newTime = moment(String(newTime + ' ' + this.order.formatted_pickup_datetime)).add(time, 'minutes').format('YYYY-MM-DD HH:mm:ss')
          } else {
            newTime = moment(String(newTime + ' ' + this.order.formatted_pickup_datetime)).subtract(time, 'minutes').format('YYYY-MM-DD HH:mm:ss')
          }
          var data = {
            id: id,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            pickup_datetime: newTime
          }
          if (moment(this.order.created_at).format('YYYY-MM-DD HH:mm:ss') > moment(newTime).format('YYYY-MM-DD HH:mm:ss')) {
            swal(
              '',
              this.$t('validations.hourIsSmallerThanCreated'),
              'error'
            )
          } else {
            const pickupFrom = this.order.pickup_datetime || null
            const loc = (this.order && this.order.production_details && this.order.production_details.location) || null
            const locationId = (loc && (loc.true_id != null ? loc.true_id : loc.id)) ||
              (this.order && this.order.location_id) ||
              null
            this.apiRequest('/order/' + id, 'PUT', data, function (response) {
              if (response.status === true) {
                self.trackAdminEvent('ADMIN_ORDER_PICKUP_DATETIME_CHANGED', 'order', id, {
                  order_id: id,
                  location_id: locationId,
                  pickup_datetime_from: pickupFrom,
                  pickup_datetime_to: (response.data && response.data[0] && response.data[0].pickup_datetime) || newTime,
                  direction: flag === 'add' ? 'add' : 'subtract',
                  minutes: time
                })
                self.order.formatted_pickup_datetime = self.formatTime(response.data[0].pickup_datetime)
                swal(
                  '',
                  self.$t('orders.orderHourSuccess'),
                  'success'
                )
                // self.callback(id, null, response.data[0].pickup_datetime)
              } else {
                swal(
                  '',
                  this.$t('validations.wentWrong'),
                  'error'
                )
              }
            })
          }
        }
      },
      saveComment () {
        var id = this.route.params.id
        var data = {
          id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          backoffice_comments: this.order.backoffice_comments
        }
        var self = this
        this.apiRequest('/order/' + id, 'PUT', data, function (response) {
          // console.warn(response)
          if (response.status === true) {
            swal(
              '',
              self.$t('orders.orderCommnetSuccess'),
              'success'
            )
          } else {
            swal(
              '',
              this.$t('validations.wentWrong'),
              'error'
            )
          }
        })
      },
      sendOrderToPrintSections (orderId, printToIp) {
        swal({
          title: 'Printing Sections',
          html: 'Please wait...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          onOpen: () => {
            swal.showLoading()
          }
        })

        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          order_id: orderId
        }

        this.apiRequest('/get-order-for-local-printer', 'POST', data, (response) => {
          if (response.status) {
            const sectionDataToSendToLocal = {
              order: response.data.order,
              printers: response.data.printers
            }

            const receiptDataToSendToLocal = {
              order: response.data.order,
              printers: response.data.printersForReceipt
            }

            let $msg = ''
            let oneErrorMsg = 'success'

            if (response.data.printers.length) {
              this.localRequest(printToIp, '/print-sections', 'POST', sectionDataToSendToLocal, (sectionRsp) => {
                if (sectionRsp.status === 200) {
                  sectionRsp.data.data.forEach(printerResponse => {
                    if (printerResponse.status) {
                      if (printerResponse.message && printerResponse.message === 'No items to print') {
                        return
                      }
                      $msg += 'Sectia: ' + printerResponse.printerSectionName + ' s-a printat cu succes!\n'
                    } else {
                      $msg += 'Eroare sectia: ' + printerResponse.printerSectionName + '\n'
                      oneErrorMsg = 'error'
                    }
                  })
                } else {
                  $msg += `Eroare: sectiuni - ${printToIp} inaccesibil sau proxy nu functioneaza.\n`
                  oneErrorMsg = 'error'
                }
                if (response.data.printersForReceipt.length) {
                  this.localRequest(printToIp, '/print', 'POST', receiptDataToSendToLocal, (receiptRsp) => {
                    if (receiptRsp.status === 200) {
                      receiptRsp.data.data.forEach(printerResponse => {
                        if (printerResponse.status) {
                          $msg += 'Nota de plata s-a printat cu succes!\n'
                        } else {
                          $msg += 'Eroare nota de plata' + '\n'
                          oneErrorMsg = 'error'
                        }
                      })
                    } else {
                      $msg += `Eroare: bonuri - ${printToIp} inaccesibil sau proxy nu functioneaza.\n`
                      oneErrorMsg = 'error'
                    }
                  })
                }

                swal({
                  title: oneErrorMsg === 'success' ? 'Succes!' : 'Rezultat printare',
                  html: $msg.replace(/\n/g, '<br>'),
                  type: oneErrorMsg,
                  confirmButtonText: 'OK',
                  allowOutsideClick: false
                })
              })
            } else if (response.data.printersForReceipt.length) {
              this.localRequest(printToIp, '/print', 'POST', receiptDataToSendToLocal, (receiptRsp) => {
                if (receiptRsp.status === 200) {
                  receiptRsp.data.data.forEach(printerResponse => {
                    if (printerResponse.status) {
                      $msg += 'Nota de plata s-a printat cu succes!\n'
                    } else {
                      $msg += 'Eroare nota de plata' + '\n'
                      oneErrorMsg = 'error'
                    }
                  })
                } else {
                  $msg += `Eroare: bonuri - ${printToIp} inaccesibil sau proxy nu functioneaza.\n`
                  oneErrorMsg = 'error'
                }

                swal({
                  title: oneErrorMsg === 'success' ? 'Succes!' : 'Rezultat printare',
                  html: $msg.replace(/\n/g, '<br>'),
                  type: oneErrorMsg,
                  confirmButtonText: 'OK',
                  allowOutsideClick: false
                })
              })
            }
          } else {
            swal({
              title: 'Error',
              text: 'Failed to load order for printing',
              type: 'error',
              confirmButtonText: 'OK'
            })
          }
        })
      },
      beforeUpdateStatus (requestStatus, orderStatus) {
        // the this.order is the OLD ORDER!!!!!!
        if (requestStatus === true) {
          const orderId = (this.order && this.order.id) || this.route.params.id
          const loc = (this.order && this.order.production_details && this.order.production_details.location) || null
          const locationId = (loc && (loc.true_id != null ? loc.true_id : loc.id)) ||
            (this.order && this.order.location_true_id) ||
            (this.order && this.order.location_id) ||
            null
          this.trackAdminEvent('ADMIN_ORDER_STATUS_CHANGED', 'order', orderId, {
            order_id: orderId,
            location_id: locationId,
            status_from: (this.order && this.order.status && this.order.status.id) || null,
            status_to: orderStatus
          })
          if (orderStatus === 'PROCESSING') {
            const printToIp = JSON.parse(this.$session.get('userData')).server_ip_port
            if (printToIp && printToIp !== '') {
              this.sendOrderToPrintSections(this.order.id, printToIp)
            }
          }
        }
      },
      updateStatus (status, label, disabled, revertOnCancel = false) {
        if (disabled) {
          return false
        }
        var self = this
        if (status === 'CANCELED') {
          swal({
            input: 'textarea',
            inputAttributes: {
              maxlength: 255
            },
            showCancelButton: true,
            inputPlaceholder: this.$t('orders.cancelReason'),
            confirmButtonText: this.$t('addOrder.btnPopup'),
            showLoaderOnConfirm: true,
            text: self.$t('validations.areYouSure') + this.changeDeliveryStatus(status),
            type: 'question',
            cancelButtonText: this.$t('general.cancel2'),
            allowOutsideClick: false,
            preConfirm: (val) => {
              if (!val) {
                document.getElementById('swal2-validationerror').innerText = this.$t('validations.cancelReason')
                document.getElementById('swal2-validationerror').setAttribute('style', 'display: block')
                document.getElementsByClassName('swal2-buttonswrapper')[0].setAttribute('class', 'swal2-buttonswrapper')
                document.getElementsByClassName('swal2-confirm swal2-styled')[0].removeAttribute('disabled')
                document.getElementsByClassName('swal2-cancel swal2-styled')[0].removeAttribute('disabled')
                return
              }
              var id = this.route.params.id
              var data2 = {
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany'),
                id: id,
                status: status,
                cancel_order_reason: val
              }
              swal({
                type: 'question',
                text: self.$t('customers.clientNotification'),
                position: 'top-end',
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: self.$t('general.yes'),
                cancelButtonText: self.$t('general.no'),
                allowOutsideClick: false
              }).then((result) => {
                if (result) {
                  data2.send_notifications = 1
                  self.cancelRKeeperOrder(id)
                  self.cancelFreyaOrder(id)
                  self.apiRequest('/order/' + id, 'PUT', data2, function (response) {
                    if (response.status === true) {
                      swal(
                        '',
                        'Sucess',
                        'success'
                      ).then(() => {
                        if (self.order.payment_type === 'CARD' || self.order.payment_type === 'SPLIT') {
                          self.refundOnCancel(response.data[0].was_delivery_before, id, status, label)
                        } else {
                          self.getData()
                          // self.callback(id, {'id': status, 'type': label})
                        }
                      })
                    } else {
                      swal(
                        {
                          text: self.$t('general.error'),
                          type: 'error',
                          showConfirmButton: false,
                          timer: 1500
                        }
                      )
                    }
                    self.beforeUpdateStatus(response.status, status)
                  })
                }
              }, function (dismiss) {
                data2.send_notifications = 0
                self.cancelRKeeperOrder(id)
                self.cancelFreyaOrder(id)
                if (dismiss === 'cancel') {
                  self.apiRequest('/order/' + id, 'PUT', data2, function (response) {
                    if (response.status === true) {
                      swal(
                        '',
                        'Sucess',
                        'success'
                      ).then(() => {
                        if (self.order.payment_type === 'CARD' || self.order.payment_type === 'SPLIT') {
                          self.refundOnCancel(response.data[0].was_delivery_before, id, status, label)
                        } else {
                          self.getData()
                          // self.callback(id, {'id': status, 'type': label})
                        }
                      })
                    } else {
                      swal(
                        {
                          title: '',
                          text: self.$t('general.error'),
                          type: 'error',
                          showConfirmButton: false,
                          timer: 1500
                        }
                      )
                      self.currentOrdersStatus = self.order.status.id
                    }
                    self.beforeUpdateStatus(response.status, status)
                  })
                  self.loading = false
                }
              })
            }
          }).then((val) => {
          }, function (dismiss) {
            if (dismiss === 'cancel') {
              self.currentOrdersStatus = self.order.status.id
              self.loading = false
            }
          })
        } else {
          swal({
            text: self.$t('validations.areYouSure') + this.changeDeliveryStatus(status),
            type: 'question',
            showCancelButton: true,
            cancelButtonText: this.$t('general.cancel2')
          })
          .then((result) => {
            if (result) {
              var id = this.route.params.id
              var data = {
                id: id,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany'),
                status: status
              }
              if (status === 'PROCESSING' && self.order.delivery_type === 'DELIVERY') {
                this.callPackageezOnProcessing()
              }
              this.apiRequest('/order/' + id, 'PUT', data, function (response) {
                if (response.status === true) {
                  // set value for refreshOrdersCount - used in SideBar.vue
                  self.$session.set('refreshOrdersCount', 'refresh')
                  let msg = self.$t('orders.orderStatusSuccess')
                  if (response.data_specials !== undefined && response.data_specials.printer_error !== undefined) {
                    msg = msg + self.$t('orders.orderPrinterError')
                  }
                  // stop sound
                  if (response.data[0].status.id !== 'NEW') {
                    self.$bus.$emit('stopSound')
                  }
                  if (response.data[0].status.id === 'CANCELED') {
                    for (var ordstat of self.orderStatuses) {
                      ordstat.isAllowed = false
                    }
                  }
                  swal({
                    text: msg,
                    type: 'success',
                    showConfirmButton: false
                    // timer: 1500
                  })
                  .then(() => {
                    let companyLocations = self.$session.get('selectedCompanyData')
                    let locationId = self.order.production_details.location.id
                    companyLocations.locations_details.forEach(async(location) => {
                      if (location.id === locationId && status === 'PROCESSING' && location.auto_print) {
                        setTimeout(() => {
                          self.printPage()
                        }, 3000)
                      }
                    })
                  })
                  if (status !== 'CANCELED') {
                    // set value for refreshOrdersCount - used in SideBar.vue
                    self.$session.set('refreshOrdersCount', 'refresh')
                    let msg = self.$t('orders.orderStatusSuccess')
                    if (response.data_specials !== undefined && response.data_specials.printer_error !== undefined) {
                      msg = msg + self.$t('orders.orderPrinterError')
                    }
                    swal({
                      text: msg,
                      type: 'success',
                      showConfirmButton: false
                      // timer: 1500
                    })
                    .then(() => {
                      let companyLocations = self.$session.get('selectedCompanyData')
                      let locationId = self.order.production_details.location.id
                      companyLocations.locations_details.forEach(async(location) => {
                        if (location.id === locationId && status === 'PROCESSING' && location.auto_print) {
                          setTimeout(() => {
                            self.printPage()
                          }, 3000)
                        }
                      })
                    })
                    self.getData()
                    // self.callback(id, {'id': status, 'type': label})
                  }
                } else if (response.errors.boogit) {
                  swal({
                    text: response.errors.boogit,
                    type: 'error',
                    showConfirmButton: false
                    // timer: 1500
                  })
                } else {
                  swal(
                    '',
                    self.$t('validations.wentWrong'),
                    'error'
                  )
                  if (revertOnCancel) {
                    self.currentOrdersStatus = self.order.status.id
                  }
                }
                self.beforeUpdateStatus(response.status, status)
              })
            }
          }).catch(() => {
            if (revertOnCancel) {
              self.currentOrdersStatus = self.order.status.id
              self.loading = false
            }
          })
        }
      },
      changeStatus () {
        var status = this.currentOrdersStatus
        var label = this.$t('ordersStatus.' + this.currentOrdersStatus)
        this.loading = true
        this.updateStatus(status, label, false, true).then(() => {
          this.loading = false
        })
      },
      changeStatusFromButtons (type) {
        if (type === this.currentOrdersStatus) {
          swal({
            text: this.$t('orders.sameStatus') + this.$t('ordersStatus.' + this.currentOrdersStatus),
            type: 'error',
            timer: 1000,
            showConfirmButton: false
          })
        } else {
          this.currentOrdersStatus = type
          var status = this.currentOrdersStatus
          var label = this.$t('ordersStatus.' + this.currentOrdersStatus)
          this.loading = true
          this.updateStatus(status, label, false, true)
          this.loading = false
        }
      },
      printPage () {
        window.print()
      },
      sendToPrinter () {
        this.$nextTick(() => {
          this.loading = true
        })
        var id = this.route.params.id
        var data = {
          token: this.$session.get('token')
        }
        var self = this
        this.apiRequest('/print/' + id, 'GET', data, function (response) {
          self.$nextTick(function () {
            self.loading = false
          })
          if (response.status === true) {
            swal(
              '',
              self.$t('orders.printerSuccess'),
              'success'
            )
          } else {
            swal(
              '',
              self.$t('orders.printerErrror'),
              'error'
            )
          }
        })
      },
      closePaymentModal () {
        this.$modal.hide('paymentModal')
      },
      printFiscal () {
        this.$modal.show('paymentModal')
      },
      processPrinter (payMethod) {
        this.closePaymentModal()
        var data = {
          token: this.$session.get('token'),
          pay_method: payMethod,
          with_pos: true,
          company_id: this.$session.get('selectedCompany'),
          capture_transaction_response: '',
          receipt_number: '',
          cui: this.cui,
          orderid: this.route.params.id,
          total: this.order['totals_grandtotal']
        }
        this.$bus.$emit('fiscalEvent', data)
      },
      changeDeliveryStatusForLabel (status) {
        var self = this
        if (status === 'DELIVERED' && self.order.delivery_type === 'EAT_LOCATION') {
          status = 'RESERVED'
        }
        if (status === 'DELIVERED' && self.order.delivery_type === 'PICK_UP') {
          status = 'COMPLETED'
        }
        return this.$t('ordersStatus.' + status)
      },
      changeDeliveryStatus (status) {
        var self = this
        if (status === 'DELIVERED' && self.order.delivery_type === 'EAT_LOCATION') {
          status = 'RESERVED'
        }
        if (status === 'DELIVERED' && self.order.delivery_type === 'PICK_UP') {
          status = 'COMPLETED'
        }
        if (status === 'CANCELED') {
          status = this.$t('canceledForever')
        }
        return this.$t('ordersStatus.' + status)
      },
      convetLabelingJson (labeling) {
        const label = JSON.parse(labeling)
        return label.notification
      },
      glovoCourierCall (id, locationId) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id,
          location_id: locationId
        }
        swal({
          title: this.$t('glovo.areYouSure'),
          html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;">' +
            '<div style="margin-top: 14px;"></div>' +
            '<div><label>' + this.$t('orders.courierTime') +
            '</label><select id="glovo-package-time-' + id +
            '" class="swal2-select" style="display: block; margin-top: auto;"><option value="1">' +
            this.$t('orders.now') +
            '</option><option value="15">15 min</option><option value="30">30 min</option><option value="45">45 min</option><option value="60">60 min</option></select>' +
            '<label>' + this.$t('customers.commentsLabel') + '</label>' +
            '<textarea type="text" id="glovo-comment-' + id + '" maxlength="255" rows="3" columns="4" class="form-control" style="max-width: 75%; margin: auto" placeholder="50 burgers"></textarea></div>',
          showCancelButton: true,
          cancelButtonText: this.$t('general.cancel')
        }).then((result) => {
          data.time = document.getElementById('glovo-package-time-' + id).value
          data.glovo_comment = document.getElementById('glovo-comment-' + id).value
          if (result) {
            this.apiRequest('/glovo-laas/create/' + id, 'POST', data, (response) => {
              if (response.status === true) {
                swal({
                  text: this.$t('orders.orderSentSuccess'),
                  type: 'success',
                  // timer: 1000,
                  showConfirmButton: true
                })
                // this.cancelOrder = true
                this.getData()
              } else {
                swal({
                  text: response.errors,
                  type: 'error',
                  // timer: 5000,
                  showConfirmButton: true
                })
                this.getData()
              }
            })
          }
        })
      },
      cancelGlovoCourier (id, locationId) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id,
          location_id: locationId
        }

        swal({
          text: this.$t('orders.callCourierCancel'),
          type: 'question',
          showCancelButton: true
        }).then((result) => {
          if (result) {
            this.apiRequest('/glovo-laas/cancel/' + id, 'POST', data, (response) => {
              if (response.status === true) {
                swal({
                  text: this.$t('orders.orderCancelSuccess'),
                  type: 'success',
                  timer: 1000,
                  showConfirmButton: false,
                  cancelButtonText: this.$t('general.cancel')
                })
                this.getData()
                // this.cancelOrder = false
              } else {
                swal({
                  text: response.errors,
                  type: 'error',
                  timer: 5000,
                  showConfirmButton: false
                })
                this.getData()
              }
            })
          }
        })
      },
      deliveryHeroCourierCall (id, locationId) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id,
          location_id: locationId
        }
        swal({
          title: this.$t('orders.deliveryHeroAreYouSure'),
          html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;">' +
            '<div style="margin-top: 14px;"></div>' +
            '<div><label>' + this.$t('orders.courierTime') +
            '</label><select id="delivery-hero-package-time-' + id +
            '" class="swal2-select" style="display: block; margin-top: auto;"><option value="1">' +
            this.$t('orders.now') +
            '</option><option value="15">15 min</option><option value="30">30 min</option><option value="45">45 min</option><option value="60">60 min</option></select>' +
            '<label>' + this.$t('customers.commentsLabel') + '</label>' +
            '<textarea type="text" id="delivery-hero-comment-' + id + '" maxlength="255" rows="3" columns="4" class="form-control" style="max-width: 75%; margin: auto"></textarea></div>',
          showCancelButton: true,
          cancelButtonText: this.$t('general.cancel')
        }).then((result) => {
          data.time = document.getElementById('delivery-hero-package-time-' + id).value
          data.delivery_hero_comment = document.getElementById('delivery-hero-comment-' + id).value
          if (result) {
            this.apiRequest('/delivery-hero/create/' + id, 'POST', data, (response) => {
              if (response.status === true) {
                swal({
                  text: this.$t('orders.orderSentSuccess'),
                  type: 'success',
                  showConfirmButton: true
                })
                this.getData()
              } else {
                swal({
                  text: response.errors,
                  type: 'error',
                  showConfirmButton: true
                })
                this.getData()
              }
            })
          }
        })
      },
      cancelDeliveryHeroCourier (id, locationId) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id,
          location_id: locationId
        }

        swal({
          text: this.$t('orders.callCourierCancel'),
          type: 'question',
          showCancelButton: true
        }).then((result) => {
          if (result) {
            this.apiRequest('/delivery-hero/cancel/' + id, 'POST', data, (response) => {
              if (response.status === true) {
                swal({
                  text: this.$t('orders.orderCancelSuccess'),
                  type: 'success',
                  timer: 1000,
                  showConfirmButton: false,
                  cancelButtonText: this.$t('general.cancel')
                })
                this.getData()
              } else {
                swal({
                  text: response.errors,
                  type: 'error',
                  timer: 5000,
                  showConfirmButton: false
                })
                this.getData()
              }
            })
          }
        })
      },
      woltDriveCourierCall (id, locationId) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id,
          location_id: locationId
        }
        swal({
          title: this.$t('orders.callCourier') + ' WOLT DRIVE',
          html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;">' +
            '<div style="margin-top: 14px;"></div>' +
            '<div><label>' + this.$t('orders.courierTime') +
            '</label><select id="wolt-drive-package-time-' + id +
            '" class="swal2-select" style="display: block; margin-top: auto;"><option value="1">' +
            this.$t('orders.now') +
            '</option><option value="15">15 min</option><option value="30">30 min</option><option value="45">45 min</option><option value="60">60 min</option></select>' +
            '<label>' + this.$t('customers.commentsLabel') + '</label>' +
            '<textarea type="text" id="wolt-drive-comment-' + id + '" maxlength="255" rows="3" columns="4" class="form-control" style="max-width: 75%; margin: auto" placeholder="Optional comment for courier"></textarea></div>',
          showCancelButton: true,
          cancelButtonText: this.$t('general.cancel')
        }).then((result) => {
          if (result) {
            const time = document.getElementById('wolt-drive-package-time-' + id).value
            const comment = document.getElementById('wolt-drive-comment-' + id).value

            // Fetch shipment promises
            this.apiRequest('/wolt-drive/order/' + id + '/shipment-promises?time=' + time, 'GET', data, (response) => {
              // apiRequest() wraps non-2xx as { status:false, error: <axios error> }
              const unwrappedResponse = (response && response.status === false && response.error && response.error.response && response.error.response.data)
                ? response.error.response.data
                : response

              const errorPayload = (() => {
                const candidates = [unwrappedResponse, unwrappedResponse && unwrappedResponse.data, unwrappedResponse && unwrappedResponse.data && unwrappedResponse.data.data]
                for (let i = 0; i < candidates.length; i++) {
                  const c = candidates[i]
                  if (c && c.status === false && c.errors && typeof c.errors === 'object') return c
                }
                return null
              })()

              if (errorPayload && errorPayload.errors && errorPayload.errors.error_code) {
                const codeKey = 'orders.woltDriveShipmentPromisesErrorCode_' + errorPayload.errors.error_code
                const translated = this.$t(codeKey)
                swal({
                  text: translated !== codeKey
                    ? translated
                    : (errorPayload.errors.details || errorPayload.errors.reason || this.$t('validations.wentWrong')),
                  type: 'error',
                  showConfirmButton: true
                })
                return
              }

              // Extract promises from any of these shapes:
              // - [{...}, {...}]
              // - { status: true, data: {...} }
              // - { status: true, data: [{...}] }
              // - Axios-style: { data: { status: true, data: {...} } }
              // - Raw promise: { id, pickup, price, ... }
              let promises = []

              const looksLikePromise = (obj) => {
                return !!(obj && typeof obj === 'object' && obj.id && obj.pickup && obj.price)
              }

              const pushPromiseOrArray = (value) => {
                if (!value) return
                if (Array.isArray(value)) {
                  promises = value
                  return
                }
                if (looksLikePromise(value)) {
                  promises = [value]
                }
              }

              // 1) Direct array or direct promise object
              pushPromiseOrArray(unwrappedResponse)

              // 2) { status, data } wrapper
              if (promises.length === 0 && unwrappedResponse && unwrappedResponse.data) {
                pushPromiseOrArray(unwrappedResponse.data)
              }

              // 3) Axios-style: { data: { status, data } }
              if (promises.length === 0 && unwrappedResponse && unwrappedResponse.data && unwrappedResponse.data.data) {
                pushPromiseOrArray(unwrappedResponse.data.data)
              }

              // 4) Defensive: sometimes nesting can be deeper
              if (promises.length === 0 && unwrappedResponse && unwrappedResponse.data && unwrappedResponse.data.data && unwrappedResponse.data.data.data) {
                pushPromiseOrArray(unwrappedResponse.data.data.data)
              }

              if (promises.length === 0) {
                swal({
                  text: this.$t('orders.noShipmentPromises'),
                  type: 'error',
                  showConfirmButton: true
                })
                // Debug helper so we can see what FE actually receives (remove if noisy)
                // eslint-disable-next-line no-console
                console.log('Wolt Drive shipment-promises raw response:', unwrappedResponse)
                return
              }

              // Build HTML for confirmation (no selection UI)
              const promise = promises[0]

              const pickupEtaMinutes =
                (promise.pickup && (promise.pickup.eta_minutes || promise.pickup.eta)) ||
                promise.pickup_eta_minutes ||
                null
              const pickupEtaText = pickupEtaMinutes !== null && pickupEtaMinutes !== undefined ? `${pickupEtaMinutes} min` : 'N/A'

              const priceAmount = promise.price && (promise.price.amount !== undefined && promise.price.amount !== null) ? promise.price.amount : 'N/A'
              const priceCurrency = promise.price && promise.price.currency ? promise.price.currency : ''
              const formattedPriceAmount = typeof priceAmount === 'number' ? (priceAmount / 100).toFixed(2) : priceAmount
              const priceText = priceCurrency ? `${formattedPriceAmount} ${priceCurrency}` : `${formattedPriceAmount}`

              const validUntilText = promise.valid_until ? this.formatToCompanyTimezone(promise.valid_until) : 'N/A'

              const promisesHtml =
                '<div style="margin-top: 14px;">' +
                '<div style="padding: 12px; border: 1px solid #ddd; border-radius: 6px;">' +
                `<div><strong>Pickup ETA:</strong> ${pickupEtaText}</div>` +
                `<div><strong>Price:</strong> ${priceText}</div>` +
                `<div><strong>Valid until:</strong> ${validUntilText}</div>` +
                '</div>' +
                '</div>'

              // Show confirmation modal
              swal({
                title: this.$t('orders.confirmDeliveryDetails'),
                html: promisesHtml,
                showCancelButton: true,
                cancelButtonText: this.$t('general.cancel'),
                confirmButtonText: this.$t('scanner.confirm'),
                width: '600px'
              }).then((promiseResult) => {
                if (promiseResult) {
                  const selectedPromise = promises[0]

                  // Create delivery from selected promise
                  const deliveryData = {
                    token: this.$session.get('token'),
                    company_id: this.$session.get('selectedCompany'),
                    promise_data: selectedPromise,
                    comment: comment || ''
                  }

                  this.apiRequest('/wolt-drive/order/' + id + '/create-delivery', 'POST', deliveryData, (deliveryResponse) => {
                    // apiRequest POST now calls callback with { status:false, error: axiosError } on non-2xx.
                    // Unwrap the actual API response body from the axios error if present.
                    const unwrapped = (deliveryResponse && deliveryResponse.status === false && deliveryResponse.error && deliveryResponse.error.response && deliveryResponse.error.response.data)
                      ? deliveryResponse.error.response.data
                      : deliveryResponse

                    if (unwrapped && unwrapped.status === true) {
                      swal({
                        text: this.$t('orders.orderSentSuccess'),
                        type: 'success',
                        showConfirmButton: true
                      })
                      this.getData()
                    } else {
                      const errorText = (() => {
                        const resp = unwrapped
                        if (!resp) return this.$t('validations.wentWrong')
                        if (resp.errors && typeof resp.errors === 'object' && resp.errors.error_code) {
                          const codeKey = 'orders.woltDriveCreateDeliveryErrorCode_' + resp.errors.error_code
                          const translated = this.$t(codeKey)
                          if (translated !== codeKey) return translated
                          if (typeof resp.errors.details === 'string') return resp.errors.details
                          if (typeof resp.errors.reason === 'string') return resp.errors.reason
                        }
                        if (typeof resp.errors === 'string') return resp.errors
                        if (typeof resp.message === 'string') return resp.message
                        return this.$t('validations.wentWrong')
                      })()
                      swal({
                        text: errorText,
                        type: 'error',
                        showConfirmButton: true
                      })
                      this.getData()
                    }
                  })
                }
              })
            })
          }
        })
      },
      cancelWoltDriveCourier (id, locationId) {
        const self = this
        swal({
          input: 'textarea',
          inputAttributes: {
            maxlength: 255
          },
          showCancelButton: true,
          inputPlaceholder: this.$t('orders.cancelReason'),
          confirmButtonText: this.$t('scanner.confirm'),
          showLoaderOnConfirm: true,
          text: this.$t('orders.callCourierCancel'),
          type: 'question',
          cancelButtonText: this.$t('general.cancel2'),
          allowOutsideClick: false,
          preConfirm: (val) => {
            if (!val) {
              swal.showValidationMessage(this.$t('validations.cancelReason'))
              return false
            }

            const data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              reason: val
            }

            const authToken = data.token ? ('Bearer ' + data.token) : ''
            const instance = self.axios.create({
              baseURL: process.env.API_BASE_URL,
              timeout: 90000,
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': authToken
              }
            })

            return instance
              .post('/wolt-drive/order/' + id + '/status/cancel', data)
              .then((res) => res.data)
              .catch((err) => {
                const errorPayload = err && err.response && err.response.data ? err.response.data : null
                return errorPayload || { status: false, errors: (err && err.message) ? err.message : 'Request failed' }
              })
          }
        }).then((result) => {
          if (result === undefined || result === null) return

          // SweetAlert2 return shapes differ across versions:
          // - Newer: { isConfirmed, dismiss, value }
          // - Older: resolves directly with preConfirm's return value
          const hasSwalShape = typeof result === 'object' && (Object.prototype.hasOwnProperty.call(result, 'value') || Object.prototype.hasOwnProperty.call(result, 'dismiss') || Object.prototype.hasOwnProperty.call(result, 'isConfirmed'))
          const isCancelled = hasSwalShape ? !!result.dismiss : false
          const isConfirmed = hasSwalShape ? (result.isConfirmed === true || (!isCancelled && result.value !== undefined)) : true
          if (!isConfirmed) return

          const response = hasSwalShape ? result.value : result
          if (response.status === true) {
            swal({
              text: self.$t('orders.orderCancelSuccess'),
              type: 'success',
              showConfirmButton: true
            })
          } else {
            const errorText = (() => {
              if (!response) return self.$t('validations.wentWrong')
              if (typeof response.errors === 'string') return response.errors
              if (response.errors && typeof response.errors === 'object' && response.errors.error_code) {
                const codeKey = 'orders.woltDriveCancelErrorCode_' + response.errors.error_code
                const translated = self.$t(codeKey)
                if (translated !== codeKey) return translated
                if (typeof response.errors.details === 'string') return response.errors.details
                if (typeof response.errors.reason === 'string') return response.errors.reason
              }
              if (typeof response.message === 'string') return response.message
              if (response.error && typeof response.error === 'string') return response.error
              try {
                if (response.errors) return JSON.stringify(response.errors)
              } catch (e) {}
              return self.$t('validations.wentWrong')
            })()
            swal({
              text: errorText,
              type: 'error',
              showConfirmButton: true
            })
          }
          self.getData()
        })
      },
      tazzCourierCall (id, locationId) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id,
          location_id: locationId
        }
        swal({
          title: this.$t('tazz.areYouSure'),
          html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;"><div style="margin-top: 14px;"></div>' + '<div><label>' + this.$t('orders.courierTime') + '</label><select id="tazz-package-time-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="1">' + this.$t('orders.now') + '</option><option value="15">15 min</option><option value="30">30 min</option></select></div>',
          showCancelButton: true,
          cancelButtonText: this.$t('general.cancel')
        }).then((result) => {
          data.time = document.getElementById('tazz-package-time-' + id).value
          if (result) {
            this.apiRequest('/tazz/create', 'POST', data, (response) => {
              if (response.status) {
                swal({
                  text: this.$t('orders.orderSentSuccess'),
                  type: 'success',
                  timer: 1000,
                  showConfirmButton: false
                })
                // this.cancelOrder = true
                this.getData()
              } else {
                swal({
                  text: response.errors.error,
                  type: 'error',
                  timer: 5000,
                  showConfirmButton: false
                })
                this.getData()
              }
            })
          }
        })
      },
      tazzLaasCourierCall (id, locationId) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id,
          location_id: locationId
        }
        swal({
          title: this.$t('tazz.areYouSure'),
          html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;"><div style="margin-top: 14px;"></div>' + '<div><label>' + this.$t('orders.courierTime') + '</label><select id="laas-tazz-package-time-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="1">' + this.$t('orders.now') + '</option><option value="15">15 min</option><option value="30">30 min</option></select></div>',
          showCancelButton: true,
          cancelButtonText: this.$t('general.cancel')
        }).then((result) => {
          let time = document.getElementById('laas-tazz-package-time-' + id).value
          if (result) {
            this.apiRequest('/tazz-laas/create/' + id + '/' + time, 'POST', data, (response) => {
              if (response.status) {
                swal({
                  text: this.$t('orders.orderSentSuccess'),
                  type: 'success',
                  timer: 1000,
                  showConfirmButton: false
                })
                // this.cancelOrder = true
                this.getData()
              } else {
                swal({
                  text: response.errors,
                  title: 'Error',
                  type: 'error',
                  timer: 5000,
                  showConfirmButton: false
                })
                this.getData()
              }
            })
          }
        })
      },
      tazzLaasCancelCourierCall (id, locationId) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id,
          location_id: locationId
        }
        swal({
          title: this.$t('tazz.areYouSureCancel'),
          // html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;"><div style="margin-top: 14px;"></div>' + '<div><label>' + this.$t('orders.courierTime') + '</label><select id="laas-tazz-package-time-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="1">' + this.$t('orders.now') + '</option><option value="15">15 min</option><option value="30">30 min</option></select></div>',
          showCancelButton: true,
          showConfirmButton: true,
          cancelButtonText: this.$t('general.no'),
          confirmButtonText: this.$t('general.yes')
        }).then((result) => {
          // let time = document.getElementById('laas-tazz-package-time-' + id).value
          if (result) {
            this.apiRequest('/tazz-laas/cancel/' + id, 'POST', data, (response) => {
              if (response.status) {
                swal({
                  text: this.$t('orders.orderSentSuccess'),
                  type: 'success',
                  timer: 1000,
                  showConfirmButton: false
                })
                // this.cancelOrder = true
                this.getData()
              } else {
                swal({
                  text: response.errors,
                  title: 'Error',
                  type: 'error',
                  timer: 5000,
                  showConfirmButton: false
                })
                this.getData()
              }
            })
          }
        })
      },
      boogitSendOrder (id) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id
        }
        this.apiRequest('/boogit/send-order/' + id, 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: this.$t('orders.orderSentSuccess'),
              type: 'success',
              timer: 1000,
              showConfirmButton: false
            })
            this.getData()
          } else {
            swal({
              text: response.errors,
              title: 'Error',
              type: 'error',
              timer: 5000,
              showConfirmButton: false
            })
            this.getData()
          }
        })
      },
      // boogitCancelOrder (id) {
      //   var data = {
      //     token: this.$session.get('token'),
      //     company_id: this.$session.get('selectedCompany'),
      //     id: id,
      //     location_id: locationId
      //   }
      //   swal({
      //     title: this.$t('general.generalAreYouSure'),
      //     showCancelButton: true,
      //     showConfirmButton: true,
      //     cancelButtonText: this.$t('general.no'),
      //     confirmButtonText: this.$t('general.yes')
      //   }).then((result) => {
      //     if (result) {
      //       this.apiRequest('/boogit/cancel-order/' + id, 'POST', data, (response) => {
      //         if (response.status) {
      //           swal({
      //             text: this.$t('orders.orderSentSuccess'),
      //             type: 'success',
      //             timer: 1000,
      //             showConfirmButton: false
      //           })
      //           this.getData()
      //         } else {
      //           swal({
      //             text: response.errors,
      //             title: 'Error',
      //             type: 'error',
      //             timer: 5000,
      //             showConfirmButton: false
      //           })
      //           this.getData()
      //         }
      //       })
      //     }
      //   })
      // },
      tazzSetOrderPrepared (orderId) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          order_id: orderId
        }

        this.apiRequest('/tazz/manual-set-prep-ready', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: this.$t('orders.orderSentSuccess'),
              type: 'success',
              timer: 1000,
              showConfirmButton: false
            })
            // this.cancelOrder = true
            this.getData()
          } else {
            swal({
              text: response.errors.error,
              type: 'error',
              timer: 5000,
              showConfirmButton: false
            })
            this.getData()
          }
        })
      },
      cancelTazzCourier (id, locationId) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id,
          location_id: locationId
        }

        swal({
          text: this.$t('orders.callCourierCancel'),
          type: 'question',
          showCancelButton: true
        }).then((result) => {
          if (result) {
            this.apiRequest('/tazz/cancel/' + id, 'POST', data, (response) => {
              if (response.status === true) {
                swal({
                  text: this.$t('orders.orderCancelSuccess'),
                  type: 'success',
                  timer: 1000,
                  showConfirmButton: false,
                  cancelButtonText: this.$t('general.cancel')
                })
                this.getData()
                // this.cancelOrder = false
              } else {
                swal({
                  text: this.$t('tazz.' + response.errors.error),
                  type: 'error',
                  timer: 5000,
                  showConfirmButton: false
                })
                this.getData()
              }
            })
          }
        })
      },
      courierHioCall (id, locationId) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id,
          location_id: locationId
        }
        swal({
          title: 'Sigur vrei sa chemi curier HIO?',
          html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;"><div style="margin-top: 14px;"></div>' + '<div><label>' + this.$t('orders.courierTime') + '</label><select id="package-time-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="1">' + this.$t('orders.now') + '</option><option value="15">15 min</option><option value="30">30 min</option></select></div>',
          showCancelButton: true,
          cancelButtonText: this.$t('general.cancel')
        }).then((result) => {
          // data.time = document.getElementById('package-time-' + id).value
          if (result) {
            this.apiRequest('/hio-send-order', 'POST', data, (response) => {
              if (response.status === true) {
                swal({
                  text: this.$t('orders.orderSentSuccess'),
                  type: 'success',
                  timer: 1000,
                  showConfirmButton: false
                })
                this.cancelOrder = true
              } else {
                swal({
                  text: response.errors,
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                })
              }
            })
          }
        })
      },
      cancelHioCourierOrder (id, locationId) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id,
          location_id: locationId
        }

        swal({
          text: this.$t('orders.callCourierCancel'),
          type: 'question',
          showCancelButton: true
        }).then((result) => {
          if (result) {
            this.apiRequest('/hio-cancel-order', 'POST', data, (response) => {
              if (response.status === true) {
                swal({
                  text: this.$t('orders.orderCancelSuccess'),
                  type: 'success',
                  timer: 1000,
                  showConfirmButton: false,
                  cancelButtonText: this.$t('general.cancel')
                })
                this.cancelOrder = false
              } else {
                swal({
                  text: response.errors,
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                })
              }
            })
          }
        })
      },
      courierCall (id, locationId) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id,
          location_id: locationId
        }
        swal({
          title: this.$t('orders.packageDetails'),
          html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;"><div style="margin-top: 14px;"><label style="margin-top: inherit;">' + this.$t('orders.packageSize') + '</label><select id="package-size-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="30x30x10">30x30x10</option><option value="30x30x20">30x30x20</option><option value="30x30x30">30x30x30</option><option value="60x60x30">60x60x30</option></select></div>' + '<div><label>' + this.$t('orders.courierTime') + '</label><select id="package-time-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="1">' + this.$t('orders.now') + '</option><option value="15">15 min</option><option value="30">30 min</option></select></div>',
          showCancelButton: true,
          cancelButtonText: this.$t('general.cancel2')
        }).then((result) => {
          data.size = document.getElementById('package-size-' + id).value
          data.time = document.getElementById('package-time-' + id).value
          if (result) {
            this.apiRequest('/packagez-send-order', 'POST', data, (response) => {
              if (response.status === true) {
                swal({
                  text: this.$t('orders.orderSentSuccess'),
                  type: 'success',
                  timer: 1000,
                  showConfirmButton: false
                })
                this.cancelOrder = true
              } else {
                swal({
                  text: this.$t('orders.contactPakageez'),
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                })
              }
            })
          }
        })
      },
      callRapidDonkey (id) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id
        }
        swal({
          title: this.$t('orders.packageDetails'),
          html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;"><div style="margin-top: 14px;"><label style="margin-top: inherit;">' + this.$t('orders.packageSize') + '</label><select id="package-size-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="30x30x10">30x30x10</option><option value="30x30x20">30x30x20</option><option value="30x30x30">30x30x30</option><option value="60x60x30">60x60x30</option></select></div>' + '<div><label>' + this.$t('orders.courierTime') + '</label><select id="package-time-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="1">' + this.$t('orders.now') + '</option><option value="15">15 min</option><option value="30">30 min</option></select></div>',
          showCancelButton: true,
          cancelButtonText: this.$t('general.cancel2')
        }).then((result) => {
          data.size = document.getElementById('package-size-' + id).value
          data.time = document.getElementById('package-time-' + id).value
          if (result) {
            this.apiRequest('/rapid-donkey-send-order', 'POST', data, (response) => {
              if (response.status === true) {
                // this.order.rapid_donkey_status = response.data.rapid_donkey_status
                Vue.set(this.order, 'rapid_donkey_status', response.data.rapid_donkey_status)
                if (response.data.rapid_donkey_status === 2) {
                  swal({
                    text: this.$t('orders.orderSentSuccess'),
                    type: 'success',
                    // timer: 1000,
                    showConfirmButton: true
                  })
                } else {
                  swal({
                    text: this.$t('orders.contactRapidDonkey'),
                    type: 'error',
                    // timer: 2000,
                    showConfirmButton: true
                  })
                }
              } else {
                swal({
                  text: this.$t('orders.contactRapidDonkey'),
                  type: 'error',
                  // timer: 2000,
                  showConfirmButton: true
                })
              }
            })
          }
        })
      },
      cancelRapidDonkey () {
        var id = this.route.params.id
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id
        }
        swal({
          input: 'textarea',
          inputAttributes: {
            maxlength: 255
          },
          showCancelButton: true,
          inputPlaceholder: this.$t('orders.cancelReason'),
          confirmButtonText: this.$t('addOrder.btnPopup'),
          showLoaderOnConfirm: true,
          text: this.$t('orders.callCourierCancel'),
          type: 'question',
          cancelButtonText: this.$t('general.cancel2'),
          allowOutsideClick: false,
          preConfirm: (val) => {
            if (!val) {
              document.getElementById('swal2-validationerror').innerText = this.$t('validations.cancelReason')
              document.getElementById('swal2-validationerror').setAttribute('style', 'display: block')
              document.getElementsByClassName('swal2-buttonswrapper')[0].setAttribute('class', 'swal2-buttonswrapper')
              document.getElementsByClassName('swal2-confirm swal2-styled')[0].removeAttribute('disabled')
              document.getElementsByClassName('swal2-cancel swal2-styled')[0].removeAttribute('disabled')
              return
            }
            data.cancel_order_reason = val
            this.apiRequest('/rapid-donkey-cancel-order', 'POST', data, (response) => {
              if (response.status === true) {
                // this.order.rapid_donkey_status = response.data.rapid_donkey_status
                Vue.set(this.order, 'rapid_donkey_status', response.data.rapid_donkey_status)
                if (response.data.rapid_donkey_status === 1) {
                  swal({
                    text: this.$t('orders.orderCancelSuccess'),
                    type: 'success',
                    // timer: 1000,
                    showConfirmButton: true
                  })
                } else {
                  swal({
                    text: this.$t('orders.contactRapidDonkey'),
                    type: 'error',
                    // timer: 2000,
                    showConfirmButton: true
                  })
                }
              } else {
                swal({
                  text: this.$t('orders.contactRapidDonkey'),
                  type: 'error',
                  // timer: 2000,
                  showConfirmButton: true
                })
              }
            })
          }
        })
      },
      cancelCourierOrder (id, locationId) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id,
          location_id: locationId
        }
        swal({
          text: this.$t('orders.callCourierCancel'),
          type: 'question',
          showCancelButton: true
        }).then((result) => {
          if (result) {
            this.apiRequest('/packagez-cancel-order', 'POST', data, (response) => {
              if (response.status === true) {
                swal({
                  text: this.$t('orders.orderCancelSuccess'),
                  type: 'success',
                  timer: 1000,
                  showConfirmButton: false,
                  cancelButtonText: this.$t('general.cancel2')
                })
                this.cancelOrder = false
              } else {
                swal({
                  text: response.errors.order,
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                })
              }
            })
          }
        })
      },
      copyToClipboard (textToCopy) {
        textToCopy = textToCopy.replace(/\s/g, '')
        this.$copyText(textToCopy).then(function (e) {
          // console.log(e)
        }, function (e) {
          // console.log(e)
        })
      },
      showOrderInIntegrationLink (orderId) {
        var dataToBeSent = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          order_id: orderId
        }
        this.apiRequest('/show_order_in_integration_link', 'GET', dataToBeSent, (response) => {
          if (response.status === true) {
            swal({
              text: this.$t('general.success'),
              type: 'success',
              timer: 1000,
              showConfirmButton: false
            })
            this.getData()
          } else {
            swal({
              text: this.$t('general.error'),
              type: 'error',
              timer: 2000,
              showConfirmButton: false
            })
          }
        })
      },
      sendToGrandchef (orderId) {
        var data = {
          order_id: orderId,
          token: this.$session.get('token')
        }

        if (!this.grandchefDelay || parseInt(Math.abs(this.grandchefDelay.getTime() - new Date().getTime()) / (1000 * 60) % 60) >= 30) {
          this.grandchefDelay = new Date()
          swal({
            text: this.$t('orders.sendToGrandchef'),
            type: 'question',
            showCancelButton: true
          }).then((result) => {
            if (result) {
              this.apiRequest('/grand-chef/send-failed-order', 'GET', data, (response) => {
                if (response.status === true) {
                  swal({
                    text: this.$t('general.success'),
                    type: 'success',
                    timer: 1000,
                    showConfirmButton: false,
                    cancelButtonText: this.$t('general.cancel2')
                  })
                  this.cancelOrder = false
                } else {
                  swal({
                    text: this.$t('orders.grandchefError'),
                    type: 'error',
                    timer: 2000,
                    showConfirmButton: false
                  })
                }
              })
            }
          })
        } else {
          swal({
            toast: true,
            type: 'warning',
            title: this.$t('orders.grandchefWait'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
        }
      },
      refundOnCancel (boolean, id, status, label) {
        if (this.order.payment_id === 'btIpay') {
          if (this.order.transaction_id && !this.refundAlreadyDone) this.handleBtReturnQueued()
          else this.getData()
          return
        }
        if (boolean) {
          swal({
            text: this.$t('orders.refundManual'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          })
          this.getData()
          // this.callback(id, {'id': status, 'type': label})
        } else {
          setTimeout(() => {
            let que = this.$t('orders.refundAutomat')
            swal({
              text: que,
              type: 'question',
              showCancelButton: true,
              cancelButtonText: this.$t('general.cancel2')
            })
            .then((res) => {
              const data2 = {
                id: id,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany'),
                status: status
              }
              this.apiRequest('/automat-refund', 'POST', data2, (response) => {
                if (response.status === true) {
                  swal({
                    text: this.$t('orders.' + response.data),
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  })
                } else {
                  swal({
                    text: this.$t('orders.' + response.errors.error),
                    type: 'error',
                    showConfirmButton: false,
                    timer: 1500
                  })
                }
                this.getData()
                // this.callback(id, {'id': status, 'type': label})
              })
            })
          }, 2000)
        }
      },
      editOrderPrice () {
        this.$modal.show('editPriceModal')
        this.editOrder.price = this.order.totals_grandtotal
      },
      updateOrderPrice () {
        let data = {
          order_id: this.order.id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          totals_grandtotal: this.editOrder.price,
          reason: this.editOrder.reason
        }
        this.apiRequest('/order/' + this.order.id, 'PUT', data, (response) => {
          if (response.status === true) {
            this.$modal.hide('editPriceModal')
            this.editOrder.price = 0
            this.editOrder.reason = ''
            this.getData()
          } else {
            swal({
              text: response.errors.order,
              type: 'error',
              timer: 2000,
              showConfirmButton: false
            })
          }
        })
      },
      cancelFreyaOrder (id) {
        if (this.order.freya_status !== 0) {
          var data = {
            token: this.$session.get('token')
          }
          this.apiRequest(process.env.API_BASE_URL + 'freya/cancel-order/' + id, 'POST', data, (response) => {})
        }
      },
      resendOrderToFreya (orderId) {
        this.order.freya_status = 1
        var data = {
          token: this.$session.get('token'),
          order_id: orderId
        }
        this.apiRequest(process.env.API_BASE_URL + 'freya/send-order/' + orderId, 'POST', data, (response) => {
          this.order.freya_status = response.status ? 2 : 3
        })
      },
      resendOrderToRKeeper (orderId) {
        this.order.rkeeper_status = 1
        var data = {
          token: this.$session.get('token'),
          order_id: orderId
        }
        this.apiRequest(process.env.API_BASE_URL + 'send-order-rkeeper/' + orderId, 'POST', data, (response) => {
          if (response && response.data && response.data.order_status) {
            this.order.rkeeper_status = response.data.order_status
          }
        })
      },
      cancelRKeeperOrder (orderId) {
        var data = {
          token: this.$session.get('token'),
          order_id: orderId
        }
        if (this.order.rkeeper_status !== 0) {
          this.apiRequest(process.env.API_BASE_URL + 'cancel-order-rkeeper/' + orderId, 'POST', data, (response) => {})
        }
      },
      callChopChopDriver (id) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          order_id: id
        }
        swal({
          title: this.$t('orders.callDriver'),
          html: '',
          showCancelButton: true,
          cancelButtonText: this.$t('general.cancel2')
        }).then((result) => {
          if (result) {
            this.apiRequest('/chopchop-add-order', 'POST', data, (response) => {
              if (response.status === true) {
                // this.order.rapid_donkey_status = response.data.rapid_donkey_status
                Vue.set(this.order, 'call_chopchop', response.data.call_chopchop)
                if (response.data.call_chopchop === 2) {
                  swal({
                    text: this.$t('orders.orderSentSuccess'),
                    type: 'success',
                    // timer: 1000,
                    showConfirmButton: true
                  })
                } else {
                  swal({
                    text: this.$t('orders.contactChopChop'),
                    type: 'error',
                    // timer: 2000,
                    showConfirmButton: true
                  })
                }
              } else {
                swal({
                  text: this.$t('orders.contactChopChop'),
                  type: 'error',
                  // timer: 2000,
                  showConfirmButton: true
                })
              }
            })
          }
        })
      },
      cancelChopChopDriver () {
        var id = this.route.params.id
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          order_id: id
        }
        swal({
          input: 'textarea',
          inputAttributes: {
            maxlength: 255
          },
          showCancelButton: true,
          inputPlaceholder: this.$t('orders.cancelReason'),
          confirmButtonText: this.$t('addOrder.btnPopup'),
          showLoaderOnConfirm: true,
          text: this.$t('orders.callCourierCancel'),
          type: 'question',
          cancelButtonText: this.$t('general.cancel2'),
          allowOutsideClick: false,
          preConfirm: (val) => {
            if (!val) {
              document.getElementById('swal2-validationerror').innerText = this.$t('validations.cancelReason')
              document.getElementById('swal2-validationerror').setAttribute('style', 'display: block')
              document.getElementsByClassName('swal2-buttonswrapper')[0].setAttribute('class', 'swal2-buttonswrapper')
              document.getElementsByClassName('swal2-confirm swal2-styled')[0].removeAttribute('disabled')
              document.getElementsByClassName('swal2-cancel swal2-styled')[0].removeAttribute('disabled')
              return
            }
            data.cancel_order_reason = val
            this.apiRequest('/chopchop-cancel-order', 'POST', data, (response) => {
              if (response.status === true) {
                Vue.set(this.order, 'call_chophop', response.data.call_chophop)
                if (response.data.chopchop_response === 1) {
                  swal({
                    text: this.$t('orders.orderCancelSuccess'),
                    type: 'success',
                    // timer: 1000,
                    showConfirmButton: true
                  })
                } else {
                  swal({
                    text: this.$t('orders.contactRapidDonkey'),
                    type: 'error',
                    // timer: 2000,
                    showConfirmButton: true
                  })
                }
              } else {
                swal({
                  text: this.$t('orders.contactRapidDonkey'),
                  type: 'error',
                  // timer: 2000,
                  showConfirmButton: true
                })
              }
            })
          }
        })
      },
      callDrCarmen (id) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id
        }
        swal({
          title: this.$t('orders.packageDetails'),
          // html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;"><div style="margin-top: 14px;"><label style="margin-top: inherit;">' + this.$t('orders.packageNumber') + '</label><input type="number" id="package-number-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"></div>',
          html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;">' +
            '<div style="margin-top: 14px;"></div>' +
            '<div><label>' + this.$t('orders.courierTime') +
            '</label><select id="drcarmen-package-time-' + id +
            '" class="swal2-select" style="display: block; margin-top: auto;"><option value="60">' +
            this.$t('orders.now') +
            '</option><option value="900">15 min</option><option value="1800">30 min</option><option value="2700">45 min</option><option value="3600">60 min</option></select>' +
            '<label style="margin-top: inherit;">' + this.$t('orders.packageNumber') + '</label><input type="number" id="package-number-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"></div>',
          showCancelButton: true,
          cancelButtonText: this.$t('general.cancel2')
        }).then((result) => {
          data.time = document.getElementById('drcarmen-package-time-' + id).value
          data.packages = document.getElementById('package-number-' + id).value
          if (result) {
            this.apiRequest('/drcarmen-add-order', 'POST', data, (response) => {
              if (response.status === true) {
                Vue.set(this.order, 'dr_carmen_status', response.data.drcarmen_status)
                swal({
                  text: this.$t('orders.orderSentSuccess'),
                  type: 'success',
                  // timer: 1000,
                  showConfirmButton: true
                })
              } else {
                swal({
                  text: response.errors.error,
                  type: 'error',
                  // timer: 2000,
                  showConfirmButton: true
                })
              }
            })
          }
        })
      },
      cancelDrCarmen (id) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id
        }
        this.apiRequest('/drcarmen-cancel-order', 'POST', data, (response) => {
          if (response.status === true) {
            Vue.set(this.order, 'dr_carmen_status', 0)
            swal({
              text: response.data.drcarmen_status,
              type: 'success',
              // timer: 1000,
              showConfirmButton: true
            })
          } else {
            swal({
              text: this.$t('orders.contactDrCarmen'),
              type: 'error',
              // timer: 2000,
              showConfirmButton: true
            })
          }
        })
      },
      isFiscalized () {
        return this.order && this.order.company && this.order.company.print_fiscal_from_dashboard && this.order.receipt_number && this.order.receipt_number.ReceiptNumber
      },
      backButton () {
        this.$bus.$emit('refresh', this.route.params.id)
        this.$bus.$emit('close-modal', null, this.route.params.id)
      }
    }
  }
</script>
<style>
  .orders-table--items {
    border-collapse: separate;
    border-spacing: 0;
  }
  .orders-table--items thead th {
    background: #f3f0fa;
    color: #5b4b8a;
    border: none;
    font-weight: 600;
    padding: 12px 16px;
  }
  .orders-table--items thead th:first-child {
    border-radius: 8px 0 0 8px;
  }
  .orders-table--items thead th:last-child {
    border-radius: 0 8px 8px 0;
  }
  .orders-table--items tbody tr.orders-table__item-row td {
    background: #fff;
    background-clip: padding-box;
    border-top: 8px solid transparent;
    border-bottom: 1px solid #ececf3;
    box-shadow: inset 0 1px 0 #ececf3;
    padding: 14px 16px;
    vertical-align: middle;
  }
  .orders-table--items tbody tr.orders-table__item-row td:first-child {
    border-left: 1px solid #ececf3;
    border-radius: 8px 0 0 8px;
  }
  .orders-table--items tbody tr.orders-table__item-row td:last-child {
    border-right: 1px solid #ececf3;
    border-radius: 0 8px 8px 0;
  }
  .orders-table--items tbody tr.orders-table__item-row--has-options td {
    border-bottom: none;
  }
  .orders-table--items tbody tr.orders-table__item-row--has-options td:first-child {
    border-radius: 8px 0 0 0;
  }
  .orders-table--items tbody tr.orders-table__item-row--has-options td:last-child {
    border-radius: 0 8px 0 0;
  }
  .orders-table--items tbody tr.orders-table__option-row td {
    background: #faf9fc;
    border-top: none;
    border-bottom: 1px solid #ececf3;
    padding: 10px 16px;
    vertical-align: middle;
    color: #5b4b8a;
  }
  .orders-table--items tbody tr.orders-table__option-row td:first-child {
    border-left: 1px solid #ececf3;
    border-radius: 0;
    padding-left: 32px;
    font-weight: 400;
    color: #6b6b80;
  }
  .orders-table--items tbody tr.orders-table__option-row td:last-child {
    border-right: 1px solid #ececf3;
    border-radius: 0;
    font-weight: 500;
  }
  .orders-table--items tbody tr.orders-table__option-row--last td:first-child {
    border-radius: 0 0 0 8px;
  }
  .orders-table--items tbody tr.orders-table__option-row--last td:last-child {
    border-radius: 0 0 8px 0;
  }
  .orders-table__name {
    font-weight: 500;
  }
  .orders-table__option-name {
    font-weight: 400;
  }
  .orders-table__meta {
    font-size: 0.8em;
    color: #666;
    margin-top: 4px;
  }
  .order-item-discount-badge {
    display: inline-block;
    min-width: 72px;
    padding: 6px 12px;
    border-radius: 6px;
    background: #28b485;
    color: #fff;
    font-weight: 600;
    line-height: 1.2;
  }

  .capture_transaction_response_string {
    width: 100%;
    min-height: 300px;
  }
  .swal2-modal .swal2-textarea {
    width: 464px;
    height: 212px;
  }
  .wolt-drive-events-swal {
    padding: 18px 22px 14px;
  }
  .wolt-drive-events-swal .swal2-title {
    margin: 0 0 10px;
  }
  .wolt-drive-events-swal .swal2-content {
    margin: 0;
    padding: 0;
  }
  .wolt-drive-events-swal .swal2-actions {
    margin: 14px 0 0;
  }
  .wolt-drive-events-swal button.swal2-cancel.swal2-styled {
    background: #007bff !important;
    color: #fff !important;
    border-radius: 50px;
  }
  .wolt-drive-events-swal button.swal2-cancel.swal2-styled:hover {
    background: #0069d9 !important;
  }

  .mb40 {
      margin-bottom: 40px;
  }

@media screen, (min-device-pixel-ratio: 2) {
  .overflow-container {
    overflow: auto;
    white-space: nowrap;
  }

  .tablet-overflow {
    margin: 5px;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    -webkit-overflow-scrolling: touch;
  }
}
.border-bottom {
    border-bottom: 1px solid #ccc;
  }
  .group-header {
    display:flex;
    margin-block: 5px;
    font-size: 1.6em;
    padding: 10px;
    border-right: 1px solid #ccc;
    /* border-radius: 4px; */
    justify-content: space-between !important;
    flex: 1 1 auto;
  }
  .content-order-view {
    margin: 10px 15px;
  }
  .editPriceModal__footer {
    /* border-top: 1px solid #ccc; */
    padding: 10px 15px;
  }
  .header {
    padding-left: 15px;
    font-size: 2.2rem !;
    text-align: center;
  }
  .order_history_message {
    color:red;
    font-size:0.6em;
  }
  .vm--modal {
    display: grid;
    /* top: 35vh !important; */
  }
  /* @media only screen and (max-width: 1600px) {
    .editPriceModal .vm--modal {
    height: 360px !important;
  }
} */

.company-text {
  color: red;
}
.paymentModal {
  z-index: 5;
  display: grid;
}
.paymentModal__footer {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 10px 10px;
  width: 100%;
  position: sticky;
  left: 0;
  bottom: 0;
}
.payment-type-button {
  padding: 20px 10px;
  background: #20C598;
  color: #fff;
  border: 0;
  border-radius: 10px;
  font-size: 20px;
  margin-right: 5px;
  margin: 5px;
  width: calc(33% - 10px);
}
.cancel-fiscal-print {
  background: red;
  color: #fff;
}

</style>

<style scopped>
  .flex-space-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .show-loader {
    height: 100%;
    min-height: 100vh;
  }

  .position-relative {
    position: relative;
  }

  .el-loading-spinner {
    position: sticky;
  }
</style>
<style scopped>
  button.swal2-confirm.swal2-styled {
    min-width: auto !important;
  }
</style>

<style scopped>
  .order-view-payment-type-disabled {
    background: grey;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Orders/OrderView.vue